webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(287),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return settings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Admin__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_ReturnList__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_ReturnList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_ReturnList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_OrderList__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_OrderList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_OrderList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_Order__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_Order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_OrderForCentral__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_OrderForCentral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_OrderForCentral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_CollectList__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_CollectList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_CollectList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_ShopList__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_ShopList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_admin_ShopList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_ShopSettings__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_ShopSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_admin_ShopSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_meta__ = __webpack_require__(290);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_meta__["a" /* default */]);
var settings = {
  getApiRoute: function getApiRoute(routeName, params) {
    var paramsObj = typeof params === 'undefined' ? {} : params;
    var serverURI = '';
    if (__webpack_require__.i({"NODE_ENV":"production","API_URL":"//bck.bck-omniway.patrizia.aryton.pl"}).user && __webpack_require__.i({"NODE_ENV":"production","API_URL":"//bck.bck-omniway.patrizia.aryton.pl"}).user === 'dami') {
      serverURI = '//bck.patrizia_omniway.v1';
    } else if (__webpack_require__.i({"NODE_ENV":"production","API_URL":"//bck.bck-omniway.patrizia.aryton.pl"}).user && __webpack_require__.i({"NODE_ENV":"production","API_URL":"//bck.bck-omniway.patrizia.aryton.pl"}).user === 'dami-remote') {
      serverURI = '//bck.patrizia_omniway.dev.waynet.pl';
    } else if (false) {
      serverURI = '//localhost:3000';
    } else {
      serverURI = "//bck.bck-omniway.patrizia.aryton.pl";
    }
    if (typeof this.apiRoutes[routeName] === 'string') {
      var route = this.apiRoutes[routeName];
      for (var key in paramsObj) {
        var reg = new RegExp('{' + key + '}', 'i');
        route = route.replace(reg, paramsObj[key]);
      }
      return serverURI + route;
    } else {
      return serverURI + '/' + routeName;
    }
  },

  apiRoutes: {
    /* -p suffix in route name mean tha this route support requestParams convention */
    'settings': '/settings',
    'login': '/login',
    'login-resp': '/login-resp',
    'logout': '/logout',
    'return-list': '/return',
    'return': '/return/{reference}',
    'return-stores': '/return-stores',
    /* central */
    'confirm-return': '/return/{reference}/confirm',
    'return-p': '/return-p',
    'order': '/order/{reference}',
    'order-return': '/order/{reference}/return',
    'order-return-pdf': '/pdf/order/return/{code}',
    'order-collect-pdf': '/pdf/order/collect/{reference}',
    'order-p': '/order-p',
    'shop': '/shop',
    'shop-settings': '/shop/{code}',
    'collect': '/collect/{reference}',
    'collect-stores': '/collect-stores',
    'collect-list': '/collect',
    'collect-p': '/collect-p',
    // helper services
    'order-states': '/order-p-states',
    'collect-states': '/collect-p-states',
    'return-states': '/return-p-states',
    'customer': '/customer/{id_customer}'
    // dispatches: {
    //   url: '/dispatches'
    // }
  },
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login___default.a
  }, {
    path: '/admin',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Admin___default.a,
    children: [{
      path: 'order-list/:reference',
      name: 'Order',
      component: __WEBPACK_IMPORTED_MODULE_6__components_admin_Order___default.a
    }, {
      path: 'order-list',
      name: 'OrderList',
      component: __WEBPACK_IMPORTED_MODULE_5__components_admin_OrderList___default.a,
      meta: {
        keepalive: true
      }
    }, {
      path: 'return-list/:reference',
      name: 'Return',
      component: __WEBPACK_IMPORTED_MODULE_7__components_admin_OrderForCentral___default.a
    }, {
      path: 'return-list',
      name: 'ReturnList',
      component: __WEBPACK_IMPORTED_MODULE_4__components_admin_ReturnList___default.a
    }, {
      path: 'collect-list/:reference',
      name: 'Collect',
      component: __WEBPACK_IMPORTED_MODULE_7__components_admin_OrderForCentral___default.a
    }, {
      path: 'collect-list',
      name: 'CollectList',
      component: __WEBPACK_IMPORTED_MODULE_8__components_admin_CollectList___default.a
    }, {
      path: 'shop-list/:code',
      name: 'ShopSettings',
      component: __WEBPACK_IMPORTED_MODULE_10__components_admin_ShopSettings___default.a
    }, {
      path: 'shop-list',
      name: 'ShopList',
      component: __WEBPACK_IMPORTED_MODULE_9__components_admin_ShopList___default.a
    }]
  }, {
    path: '/*',
    redirect: function redirect(to) {
      return '/';
    }
  }]
};
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */](settings));

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateRangesFilter: null
    };
  },
  mounted: function mounted() {
    this.dateRangesFilter = this.dateRanges();
  },

  methods: {
    dateRanges: function dateRanges() {
      var now = Date.now();
      var day = new Date(now);
      day.setSeconds(0);
      day.setMinutes(0);
      day.setHours(0);
      var week = new Date(now - 1000 * 60 * 60 * 24 * 6);
      week.setSeconds(0);
      week.setMinutes(0);
      week.setHours(0);
      var month = new Date(now - 1000 * 60 * 60 * 24 * 29);
      month.setSeconds(0);
      month.setMinutes(0);
      month.setHours(0);
      return [{ value: month.toISOString(), name: this.$tr('Miesiąc', 'ReturnList') }, { value: week.toISOString(), name: this.$tr('Tydzień', 'ReturnList') }, { value: day.toISOString(), name: this.$tr('Dzień', 'ReturnList') }];
    }
  }
});

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Dropdown__);


__WEBPACK_IMPORTED_MODULE_0__Dropdown___default.a.install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__Dropdown___default.a.name, __WEBPACK_IMPORTED_MODULE_0__Dropdown___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Dropdown___default.a);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paginator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paginator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Paginator__);


__WEBPACK_IMPORTED_MODULE_0__Paginator___default.a.install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__Paginator___default.a.name, __WEBPACK_IMPORTED_MODULE_0__Paginator___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Paginator___default.a);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Radio__);


__WEBPACK_IMPORTED_MODULE_0__Radio___default.a.install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__Radio___default.a.name, __WEBPACK_IMPORTED_MODULE_0__Radio___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Radio___default.a);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_alertifyjs__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_alertifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_alertifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





var Helper = {};

Helper.install = function (Vue, options) {
  Vue.prototype.$helper = {
    displayPrice: function displayPrice(val, currency) {
      var a = Number(val);
      return a.toString().replace('.', ',') + ' ' + currency;
    },
    emptyObject: function emptyObject(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false;
        }
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj) === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({});
    },
    stdErrors: function stdErrors(resp) {
      if (typeof resp.body.errors !== 'undefined' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(resp.body.errors).length > 0) {
        for (var e in resp.body.errors) {
          __WEBPACK_IMPORTED_MODULE_2_alertifyjs___default.a.notify(resp.body.errors[e], 'error', 3);
        }
      }
    }
  };
  Vue.prototype.$alertify = __WEBPACK_IMPORTED_MODULE_2_alertifyjs___default.a;
  Vue.prototype.$moment = __WEBPACK_IMPORTED_MODULE_3_moment___default.a;
};

/* harmony default export */ __webpack_exports__["a"] = (Helper);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tr; });
/* FRONTEND: Internationalisation to implement */

var I18n = {};
var tr = function tr($str, $ns) {
  return $str;
};

I18n.install = function (Vue, options) {
  Vue.prototype.$tr = tr;
};

/* harmony default export */ __webpack_exports__["b"] = (I18n);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_storage_helper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_storage_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_storage_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__(36);









__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default.a, {
  name: 'ls'
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);

// the root, initial state object
var storageHelperExt = {
  get: function get(state, arg) {
    var b = __WEBPACK_IMPORTED_MODULE_6_storage_helper___default.a.getItem(state);
    return JSON.parse(b);
  },
  set: function set(state, arg) {
    var a = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(arg);
    __WEBPACK_IMPORTED_MODULE_6_storage_helper___default.a.setItem(state, a);
  }
};

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
  role: null,
  shop: null,
  token: null,
  logged: 0,
  dispatchSettings: null
}, storageHelperExt.get('state'));

// define the possible mutations that can be applied to our state
var mutations = {
  LOGIN: function LOGIN(state, payload) {
    state.logged = 1;
    state.role = payload.role;
    state.token = payload.token;
    if (payload.role === 'shop' && typeof payload.shop !== 'undefined') {
      state.shop = payload.shop;
    }
    storageHelperExt.set('state', state);
  },
  LOGOUT: function LOGOUT(state) {
    state.logged = 0;
    state.role = null;
    state.token = null;
    storageHelperExt.set('state', state);
  },
  UPDATE_DISPATCH_SETTINGS: function UPDATE_DISPATCH_SETTINGS(state, payload) {
    state.dispatchSettings = payload;
    storageHelperExt.set('state', state);
  },
  SHOP: function SHOP(state, shop) {
    state.shop = shop;
    storageHelperExt.set('state', state);
  },
  REFRESH_TOKEN: function REFRESH_TOKEN(state, payload) {
    state.token = payload;
    storageHelperExt.set('state', state);
  }
};
var actions = {
  logout: function logout(context) {
    console.log(context);
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(__WEBPACK_IMPORTED_MODULE_4__router__["b" /* settings */].getApiRoute('logout'), {}, { headers: { 'x-auth-token': context.getToken } });
    context.commit('LOGOUT');
    context.commit('SHOP', null);
    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: 'Login' });
  }
};
var getters = {
  logged: function logged(state) {
    return state.logged;
  },
  getDispatchSettings: function getDispatchSettings(state) {
    return state.dispatchSettings;
  },
  getShop: function getShop(state) {
    return state.shop;
  },
  getToken: function getToken(state) {
    return state.token;
  }
};

// create the Vuex instance by combining the state and mutations objects
// then export the Vuex store for use by our components
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
}));

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(254)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(284),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */,
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_pl__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_pl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_pl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_i18n__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_helper__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_reusable_dropdown__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_reusable_radio__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_reusable_paginator__ = __webpack_require__(187);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// , { Validator }







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var veeValidateConfig = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'pl',
  dictionary: {
    plVeeValidate: __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_pl___default.a
  },
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'blur',
  inject: true,
  validity: true,
  aria: true
};

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].getters.logged) {
    if (to.name === 'Login') {
      next();
    } else {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Login' });
    }
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptor.before = function (req, next) {
  var _this = this;

  if (__WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].getters.getToken !== null) {
    req.headers.set('X-AUTH-TOKEN', __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].getters.getToken);
  }
  next(function (response) {
    if (response.status === 403 && __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.name !== 'Login') {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Login' });
      _this.$alertify.notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__plugins_i18n__["a" /* tr */])('Wymagane ponowne zalogowanie', 'General'), 'error', 3);
    }
    // token refresh
    // if (typeof response.headers !== 'undefined' && typeof response.headers.map !== 'undefined' && typeof response.headers.map['x-auth-token'] !== 'undefined') {
    //   store.commit('REFRESH_TOKEN', response.headers.map['x-auth-token'][0])
    // }
  });
};

// Validator.localize(plVeeValidate)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */], veeValidateConfig);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__plugins_i18n__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__plugins_helper__["a" /* default */]);

// reusable components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__components_reusable_dropdown__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__components_reusable_radio__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__components_reusable_paginator__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  metaInfo: {
    meta: [{ name: 'robots', content: 'noindex' }]
  },
  methods: {}
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin',
  data: function data() {
    return {
      settings: null
    };
  },
  mounted: function mounted() {
    this.settings = this.$store.getters.getDispatchSettings;
  },

  methods: {
    logout: function logout() {
      this.$store.dispatch('logout');
    }
  },
  computed: {
    isDispatch: function isDispatch() {
      return this.$store.state.role === 'dispatch';
    },
    loggedShop: function loggedShop() {
      return this.$store.getters.getShop;
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      dev: false,
      visibleSubdomain: false,
      isFormReady: false,
      subdomain: '',
      username: '',
      password: '',
      validateRules: {
        username: { rules: { required: true } },
        password: { rules: { required: true } }
      },
      settings: null
    };
  },

  watch: {
    // for later implementation
  },
  methods: {
    tr: function tr(arg, ns) {
      //      console.log('translator implementation')
      return arg;
    },
    loginAction: function loginAction() {
      var _this = this;

      if (this.errors.count()) {
        return false;
      }
      this.$http.post(this.$router.options.getApiRoute('login'), {
        username: this.username,
        password: this.password,
        subdomain: this.subdomain
      }).then(function (resp) {
        console.log(resp);
        if (resp.ok && resp.status === 200) {
          _this.successAction(resp.body);
          if (resp.body.role === 'shop') {
            _this.$router.push('/admin/order-list');
          } else {
            _this.$router.push('/admin/return-list');
          }
        } else {
          _this.errorAction();
          _this.$alertify.notify(_this.$tr('Błędne dane', 'Order'), 'error', 3);
        }
      }, function (resp) {
        _this.errorAction();
        _this.$alertify.notify(_this.$tr('Błędne dane', 'Order'), 'error', 3);
        console.log('err:');
        console.log(resp);
      });
    },
    successAction: function successAction(resp) {
      this.$store.commit('LOGIN', resp);
      return true;
    },
    errorAction: function errorAction() {
      this.$store.commit('LOGOUT');
      return false;
    },
    inspectURL: function inspectURL() {
      if (typeof window.location === 'undefined' || this.dev) {
        this.visibleSubdomain = true;
        return;
      }
      var location = window.location.hostname;
      var parts = location.split('.');
      if (parts.length < 3) {
        this.visibleSubdomain = true;
        return;
      }
      this.subdomain = parts[0];
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // inactive until logo adding functionality will not be implemented
    //    this.$http.get(this.$router.options.getApiRoute('settings'))
    //      .then((res) => {
    //        this.settings = res.body
    //        this.$store.commit('UPDATE_DISPATCH_SETTINGS', res.body)
    //      })
    this.inspectURL();
    setTimeout(function () {
      _this2.isFormReady = true;
    }, 150);
  },

  computed: {
    // later use
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_ranges__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_date_ranges__["a" /* default */]],
  components: { Paginator: __WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue___default.a },
  name: 'collect-list',
  data: function data() {
    return {
      list: [],
      defaultPerPage: { name: 3, value: 3 },
      itemsPerPage: [{ name: 3, value: 3 }, { name: 6, value: 6 }, { name: 12, value: 12 }, { name: 24, value: 24 }, { name: 48, value: 48 }],
      currentPerPage: 3,
      filterByStates: [],
      defaultByStates: {},
      pageContent: [],
      filteredCount: 1,
      fList: null,
      periodsRadioFilter: null,
      /* table sort functionality */
      sortKey: 'name',

      reverse: false,

      searchValue: '',
      search: '',

      columns: {},
      paginatorPassive: true,
      requestParams: {
        route: 'collect-list',
        params: {}
      },
      requestUpdateForce: 1,
      // filter by stores
      storesFilter: [],
      storesDefaultFilter: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.columns = {
      'reference': this.$tr('Nr zamówienia', 'CollectList'),
      'shop': this.$tr('Sklep', 'CollectList'),
      'date': this.$tr('Data', 'CollectList'),
      'name': this.$tr('Imię i nazwisko', 'CollectList'),
      'data': this.$tr('Dane kontaktowe', 'CollectList'),
      'status': this.$tr('Status zamówienia', 'CollectList')
    };
    this.defaultByStates = { name: this.$tr('Wszystkie odbiory', 'CollectList'), value: null };
    this.filterByStates.push(this.defaultByStates);
    this.$http.get(this.$router.options.getApiRoute('collect-states')).then(function (r) {
      var statesFilters = r.body.states.map(function (el, key) {
        return {
          name: el,
          value: el
        };
      });
      _this.filterByStates = _this.filterByStates.concat(statesFilters);
    });
    var initialStoreFilter = {
      name: this.$tr('--', 'ReturnList'),
      value: null
    };
    this.storesDefaultFilter = initialStoreFilter;
    this.storesFilter.push(initialStoreFilter);
    this.$http.get(this.$router.options.getApiRoute('collect-stores')).then(function (resp) {
      if (resp.ok) {
        var storesFilter = resp.body.stores.map(function (el, key) {
          return {
            name: el.name,
            value: el
          };
        });
        _this.storesFilter = _this.storesFilter.concat(storesFilter);
      }
    });
  },

  methods: {
    changePerPage: function changePerPage(ev) {
      this.currentPerPage = ev;
    },
    changeFilterByState: function changeFilterByState(val, filterkey) {
      filterkey = typeof filterkey !== 'undefined' ? filterkey : 'status';
      if (val !== null) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.requestParams.params['filter']) !== 'object') {
          this.requestParams.params['filter'] = {};
        }
        this.requestParams.params.filter['status'] = val;
      } else {
        if (typeof this.requestParams.params['filter'] !== 'undefined' && typeof this.requestParams.params['filter']['status'] !== 'undefined') {
          delete this.requestParams.params['filter']['status'];
        }
      }
      this.requestUpdateForce++;
    },
    changeFilterByStore: function changeFilterByStore(val) {
      if (val !== null) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.requestParams.params['filter']) !== 'object') {
          this.requestParams.params['filter'] = {};
        }
        this.requestParams.params.filter['shop'] = val;
      } else {
        if (typeof this.requestParams.params['filter'] !== 'undefined' && typeof this.requestParams.params['filter']['shop'] !== 'undefined') {
          delete this.requestParams.params['filter']['shop'];
        }
      }
      this.requestUpdateForce++;
    },
    changeDateRange: function changeDateRange(val) {
      if (val !== null) {
        var to = new Date(Date.now());
        to.setSeconds(59);
        to.setMinutes(59);
        to.setHours(23);
        this.requestParams.params['date_from'] = val;
        this.requestParams.params['date_to'] = to.toISOString();
      } else {
        if (typeof this.requestParams.params['date_from'] !== 'undefined') {
          delete this.requestParams.params['date_from'];
        }
        if (typeof this.requestParams.params['date_to'] !== 'undefined') {
          delete this.requestParams.params['date_to'];
        }
      }
      this.requestUpdateForce++;
    },
    searchAction: function searchAction() {
      if (this.paginatorPassive) {
        if (this.searchValue !== '') {
          this.requestParams.params['query'] = this.searchValue;
        } else {
          delete this.requestParams.params['query'];
        }
        this.requestUpdateForce++;
      } else {
        this.search = this.searchValue;
      }
    },
    sortBy: function sortBy(sortKey) {
      this.reverse = this.sortKey === sortKey ? !this.reverse : false;
      this.sortKey = sortKey;
    },
    updatePageContent: function updatePageContent(content) {
      this.pageContent = content;
    },
    highlight: function highlight(words, query) {
      var iQuery = new RegExp(query, 'ig');
      return words.toString().replace(iQuery, function (matchedTxt) {
        return '<span class="highlight">' + matchedTxt + '</span>';
      });
    }
  },
  computed: {
    filteredList: function filteredList() {
      var filtered = this.list;
      if (this.search !== '') {
        var pattern = new RegExp(this.search, 'i');
        filtered = filtered.filter(function (item) {
          return item.firstname.match(pattern) || item.lastname.match(pattern) || item.reference.match(pattern);
        });
      }
      this.filteredCount = filtered.length;
      return filtered;
    },
    noContent: function noContent() {
      return !(this.pageContent instanceof Array && this.pageContent.length);
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var FileSaver = __webpack_require__(259);
// PDF debug
var debug = 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Paginator: __WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue___default.a },
  name: 'order',
  data: function data() {
    return {
      order: null,
      notFound: false,
      states: null,
      defaultState: null,
      choosedState: null,
      returnProd: {},
      returnProducts: {},
      message: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (typeof this.$route.params.reference !== 'undefined') {
      this.$http.get(this.$router.options.getApiRoute('order', { reference: this.$route.params.reference })).then(function (resp) {
        if (typeof resp.body[0] !== 'undefined') {
          console.log(resp.body[0]);
          _this.order = resp.body[0];
          if (_this.order.ready_for_collection) {
            _this.defaultState = _this.states[0];
            _this.choosedState = _this.states[0].value;
          }
        } else {
          _this.notFound = true;
        }
      }, function (resp) {
        console.log(resp.body);
        _this.notFound = true;
      });
    }

    /* status dropdown */
    this.states = [{ name: this.$tr('Gotowe do odbioru', 'Order'), value: 'ready_to_collect' }, { name: this.$tr('Odebrane', 'Order'), value: 'collected'
      /* {name: this.$tr('Nieodebrane', 'Order'), value: 24} */
    }];
    // actions
  },

  methods: {
    changeChoosedState: function changeChoosedState(val, key) {
      this.choosedState = val;
    },
    validatePDFResponse: function validatePDFResponse(response) {
      if (typeof response.headers.map['content-type'] !== 'undefined') {
        var ct = response.headers.map['content-type'];
        ct = ct instanceof Array ? ct.join('') : ct;
        if (ct === 'application/json') {
          var error = this.$tr('Wystąpił błąd', 'Order');
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(response.data) === 'object' && response.data.error) {
            error = response.data.error;
          }
          this.$alertify.notify(this.$tr(error, 'Order'), 'error', 3);
          return false;
        }
      }
      return true;
    },
    pdfDebug: function pdfDebug(response) {
      if (debug) {
        var ifr = document.getElementById('PDF_PREVIEW_IFRAME');
        if (!ifr) {
          ifr = document.createElement('iframe');
          ifr.id = 'PDF_PREVIEW_IFRAME';
          var body = document.getElementsByTagName('body')[0];
          body.appendChild(ifr);
        }
        var factor = 794 / 210;
        ifr.width = parseInt(210 * factor);
        ifr.height = parseInt(297 * factor);
        ifr.style.width = '21cm';
        ifr.style.height = '29.7cm';
        ifr.style.margin = '0 auto';
        ifr.style.border = 'none';
        ifr.style.display = 'block';
        var iframeElementContainer = document.getElementById('PDF_PREVIEW_IFRAME').contentDocument;
        iframeElementContainer.open();
        iframeElementContainer.write(response.data.html);
        iframeElementContainer.close();
        return;
      } else {
        var _ifr = document.getElementById('PDF_PREVIEW_IFRAME');
        if (_ifr) {
          _ifr.remove();
        }
      }
    },
    downloadReturnPDF: function downloadReturnPDF(ev, code) {
      var _this2 = this;

      ev.preventDefault();
      this.$http.post(this.$router.options.getApiRoute('order-return-pdf', { code: code }), { debug: debug }, {
        headers: {
          'Accept': 'application/pdf'
        },
        responseType: debug ? 'json' : 'blob'
      }).then(function (response) {
        if (!_this2.validatePDFResponse(response)) {
          return;
        }
        _this2.pdfDebug(response);
        var fileName = 'return.pdf';
        if (typeof response.headers.map['x-filename'] !== 'undefined') {
          fileName = response.headers.map['x-filename'];
        }
        FileSaver.saveAs(new Blob([response.body], { type: 'application/pdf;charset=utf-8' }), fileName);
        return response;
      }).catch(function (response) {
        _this2.$alertify.notify(_this2.$tr('Wystąpił błąd', 'Order'), 'error', 3);
      });
    },
    downloadCollectPDF: function downloadCollectPDF(ev, reference) {
      var _this3 = this;

      ev.preventDefault();
      this.$http.post(this.$router.options.getApiRoute('order-collect-pdf', { reference: reference }), { debug: debug }, {
        headers: {
          'Accept': 'application/pdf'
        },
        responseType: debug ? 'json' : 'blob'
      }).then(function (response) {
        if (!_this3.validatePDFResponse(response)) {
          return;
        }
        _this3.pdfDebug(response);
        var fileName = 'return.pdf';
        if (typeof response.headers.map['x-filename'] !== 'undefined') {
          fileName = response.headers.map['x-filename'];
        }
        FileSaver.saveAs(new Blob([response.body], { type: 'application/pdf;charset=utf-8' }), fileName);
        return response;
      }).catch(function (response) {
        _this3.$alertify.notify(_this3.$tr('Wystąpił błąd', 'Order'), 'error', 3);
      });
    },
    pushOrderState: function pushOrderState() {
      var _this4 = this;

      if (!this.choosedState) {
        this.$alertify.notify(this.$tr('Wybierz status do aktualizacji', 'Order'), 'warning', 3);
        return false;
      }
      if (this.choosedState === 'ready_to_collect' && this.order.ready_for_collection) {
        this.$alertify.notify(this.$tr('Zamówienie zostało już oznaczone jako gotowe do odebrania. Zaznacz inny status.', 'Order'), 'error', 3);
        return false;
      }
      if (this.choosedState === 'collected' && this.order.ready_for_collection === 0) {
        this.$alertify.notify(this.$tr('Zamówienie nie zostało jeszcze oznaczone jako gotowe do odebrania.', 'Order'), 'error', 3);
        return false;
      }
      this.$http.post(this.$router.options.getApiRoute('order', { reference: this.$route.params.reference }), {
        state: this.choosedState
      }).then(function (resp) {
        if (resp.ok) {
          _this4.$alertify.notify(_this4.$tr('Zaktualizowano status zamówienia', 'Order'), 'success', 3);
          _this4.$router.push({ name: 'OrderList' });
        }
      }, function (resp) {
        console.log('fail:');
        console.log(resp);
        _this4.$helper.stdErrors(resp);
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(resp.body) === 'object' && resp.body.message) {
          _this4.$alertify.notify(resp.body.message, 'error', 3);
        }
      });
    },
    pushReturn: function pushReturn() {
      var _this5 = this;

      this.$http.post(this.$router.options.getApiRoute('order-return', { reference: this.$route.params.reference }), {
        products: this.returnProducts,
        summary: this.returnSummary,
        message: this.message
      }).then(function (resp) {
        console.log(resp.body);
        if (resp.ok) {
          _this5.$router.push({ name: 'OrderList' });
        }
      }, function (resp) {
        console.log('fail:');
        console.log(resp);
        _this5.$helper.stdErrors(resp);
      });
    },
    orderReturnModify: function orderReturnModify(event, product) {
      console.log(product);
      var val = Number(event.target.value);
      if (isNaN(val) && event.target.value !== '') {
        event.target.value = 0;
        val = 0;
      }
      if (val > product.quantity - product.quantity_returned) {
        event.target.value = product.quantity - product.quantity_returned;
        val = product.quantity - product.quantity_returned;
      }
      this.modifyReturnModify(val, product);
      event.target.value = val;
    },
    modifyReturnModify: function modifyReturnModify(val, product) {
      if (val === 0) {
        delete this.returnProd[product.reference];
      } else {
        this.returnProd[product.reference] = {
          name: product.name,
          quantity: val,
          price: product.price,
          currency: product.currency
        };
      }
      this.returnProducts = {};
      this.returnProducts = this.returnProd;
    }
  },
  computed: {
    anyDocumentsAvailable: function anyDocumentsAvailable() {
      return this.returnPDFCanBeDisplayed || this.collectPDFCanBeDisplayed;
    },
    returnSummary: function returnSummary() {
      var sum = 0;
      var qty = 0;
      var currency = '';
      for (var prod in this.returnProducts) {
        console.log(prod);
        sum += this.returnProducts[prod].price * this.returnProducts[prod].quantity;
        qty += this.returnProducts[prod].quantity;
        currency = this.returnProducts[prod].currency;
      }
      return {
        value: sum.toFixed(2),
        currency: currency,
        quantity: qty
      };
    },
    loggedShop: function loggedShop() {
      return this.$store.getters.getShop;
    },
    collectPDFCanBeDisplayed: function collectPDFCanBeDisplayed() {
      return (this.order.ready_for_collection || this.order.collected || this.order.state === 'Gotowe do odbioru') && !(this.order.returns_pdf && this.order.returns_pdf.length);
    },
    returnPDFCanBeDisplayed: function returnPDFCanBeDisplayed() {
      return this.order.returns_pdf && this.order.returns_pdf.length;
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Paginator: __WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue___default.a },
  name: 'order-for-central',
  data: function data() {
    return {
      editFlags: {
        account_number: false
      },
      entityName: 'order',
      order: null,
      collect_store: null,
      return_store: null,
      notFound: false,
      states: null,
      choosedState: null,
      returnProd: {},
      returnProducts: {},
      message: '',
      return_completed: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (typeof this.$route.params.reference !== 'undefined') {
      if (this.isReturn()) {
        this.entityName = 'return';
      }
      this.$http.get(this.$router.options.getApiRoute(this.entityName, { reference: this.$route.params.reference })).then(function (resp) {
        if (resp.ok && typeof resp.body[0] !== 'undefined') {
          console.log(resp.body[0]);
          _this.order = resp.body[0];
          if (_this.isCollect()) {
            _this.getStoreInfo(_this.order.store_collect.code);
          }
          if (_this.order.confirmed) {
            _this.return_completed = true;
          }
        }
      }, function (resp) {
        console.log(resp.body);
        _this.notFound = true;
      });
    }

    /* status dropdown */
    this.states = [{ name: this.$tr('Gotowe do odbioru', 'Order'), value: 'ready_to_collect' }, { name: this.$tr('Odebrane', 'Order'), value: 'collected'
      /* {name: this.$tr('Nieodebrane', 'Order'), value: 24} */
    }];
    // actions
  },

  methods: {
    changeChoosedState: function changeChoosedState(val, key) {
      this.choosedState = val;
    },
    pushOrderState: function pushOrderState() {
      var _this2 = this;

      if (!this.choosedState) {
        this.$alertify.notify(this.$tr('Wybierz status do aktualizacji', 'Order'), 'warning', 3);
        return false;
      }
      this.$http.post(this.$router.options.getApiRoute('order', { reference: this.$route.params.reference }), {
        state: this.choosedState
      }).then(function (resp) {
        if (resp.body.success) {
          _this2.$alertify.notify(_this2.$tr('Zaktualizowano status zamówienia', 'Order'), 'success', 3);
          _this2.$router.push({ name: 'OrderList' });
        }
      }, function (resp) {
        console.log('fail:');
        console.log(resp);
      });
    },
    getStoreInfo: function getStoreInfo(code) {
      var _this3 = this;

      this.$http.get(this.$router.options.getApiRoute('shop-settings', { code: code })).then(function (resp) {
        if (typeof resp.body[0] !== 'undefined') {
          console.log(resp.body[0]);
          if (_this3.isCollect()) {
            _this3.collect_store = resp.body[0];
          } else if (_this3.isReturn()) {
            _this3.return_store = resp.body[0];
          }
        }
      }, function (resp) {
        console.log(resp.body);
      });
    },
    pushReturn: function pushReturn() {
      var _this4 = this;

      this.$http.post(this.$router.options.getApiRoute('order-return', { reference: this.$route.params.reference }), {
        products: this.returnProducts,
        summary: this.returnSummary,
        message: this.message
      }).then(function (resp) {
        console.log(resp.body);
        if (resp.body.success) {
          _this4.$router.push({ name: 'OrderList' });
        }
      }, function (resp) {
        console.log('fail:');
        console.log(resp);
        _this4.$helper.stdErrors(resp);
      });
    },
    updateCustomer: function updateCustomer(obj) {
      var _this5 = this;

      this.$http.post(this.$router.options.getApiRoute('customer', { id_customer: this.order.id_customer }), obj).then(function (resp) {
        if (resp.ok) {
          _this5.$alertify.notify(_this5.$tr('Uaktualniono pomyślnie', 'Order'), 'success', 3);
          _this5.editFlags.account_number = false;
        }
      }, function (resp) {
        _this5.$helper.stdErrors(resp);
      });
    },
    confirmReturn: function confirmReturn(val) {
      var _this6 = this;

      if (!val) {
        return false;
      }
      this.$http.post(this.$router.options.getApiRoute('confirm-return', { reference: this.$route.params.reference }), {
        products: this.returnProducts,
        summary: this.returnSummary,
        message: this.message
      }).then(function (resp) {
        console.log(resp);
        if (resp.ok) {
          _this6.return_completed = true;
          _this6.$alertify.notify(_this6.$tr('Zamówienie zrealizowane', 'Order'), 'success', 3);
        }
      }, function (resp) {
        _this6.$helper.stdErrors(resp);
      });
    },
    orderReturnModify: function orderReturnModify(event, product) {
      console.log(product);
      var val = Number(event.target.value);
      if (isNaN(val) && event.target.value !== '') {
        event.target.value = 0;
        val = 0;
      }
      if (val > product.quantity) {
        event.target.value = product.quantity;
        val = product.quantity;
      }
      this.modifyReturnModify(val, product);
      event.target.value = val;
    },
    modifyReturnModify: function modifyReturnModify(val, product) {
      if (val === 0) {
        delete this.returnProd[product.reference];
      } else {
        this.returnProd[product.reference] = {
          name: product.name,
          quantity: val,
          price: product.price,
          currency: product.currency
        };
      }
      this.returnProducts = {};
      this.returnProducts = this.returnProd;
    },
    isCollect: function isCollect() {
      return this.$route.name === 'Collect';
    },
    isReturn: function isReturn() {
      return this.$route.name === 'Return';
    }
  },
  computed: {
    returnSummary: function returnSummary() {
      var sum = 0;
      var qty = 0;
      var currency = '';
      for (var prod in this.order.products) {
        console.log(prod);
        sum += this.order.products[prod].price * this.order.products[prod].quantity;
        qty += this.order.products[prod].quantity;
        currency = this.order.products[prod].currency;
      }
      return {
        value: sum.toFixed(2),
        currency: currency,
        quantity: qty
      };
    },
    isDispatch: function isDispatch() {
      return this.$store.state.role === 'dispatch';
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_timers__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_timers__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Paginator: __WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue___default.a },
  name: 'order-list',
  data: function data() {
    return {
      list: [],
      defaultPerPage: { name: 6, value: 6 },
      itemsPerPage: [{ name: 6, value: 6 }, { name: 12, value: 12 }, { name: 24, value: 24 }, { name: 48, value: 48 }],
      currentPerPage: 6,
      pageContent: [],
      filteredCount: 1,
      searchResultsCount: 0,
      fList: null,
      periodsRadioFilter: null,
      /* table sort functionality */
      sortKey: 'name',

      reverse: false,

      searchValue: '',
      search: '',

      columns: {},
      paginatorPassive: true,
      requestParams: {
        route: 'order',
        params: {}
      },
      requestUpdateForce: 1,
      activeListing: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.periodsRadioFilter = [{ value: 'month', name: this.$tr('Miesiąc', 'OrderList') }, { value: 'week', name: this.$tr('Tydzień', 'OrderList') }, { value: 'day', name: this.$tr('Dzień', 'OrderList') }];
    this.columns = {
      'reference': this.$tr('Nr zamówienia', 'OrderList'),
      'firstname': this.$tr('Imię i nazwisko', 'OrderList'),
      'data': this.$tr('Dane do przelewu', 'OrderList'),
      'date': this.$tr('Data zamówienia', 'OrderList'),
      'amount': this.$tr('Kwota zwrotu', 'OrderList'),
      'notes': this.$tr('Uwagi', 'OrderList'),
      'status': this.$tr('Status', 'OrderList'),
      'details': this.$tr('Szczegóły', 'OrderList')
    };
    if (this.$store.state.role === 'shop') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_timers__["setTimeout"])(function () {
        _this.activeListing = true;
        _this.requestUpdateForce++;
      }, 400);
      // this.requestParams.params['']
      // this.$http.get(this.$router.options.getApiRoute('order'))
      //   .then((r) => {
      //     this.list = r.body
      //     this.filteredCount = this.list.length
      //     console.log(this.list)
      //   })
    }
  },

  methods: {
    changePerPage: function changePerPage(ev) {
      this.currentPerPage = ev;
      console.log(ev);
    },
    searchAction: function searchAction() {
      if (this.paginatorPassive) {
        if (this.searchValue !== '') {
          this.requestParams.params['query'] = this.searchValue;
          this.activeListing = true;
        } else {
          delete this.requestParams.params['query'];
          this.activeListing = false;
        }
        this.requestUpdateForce++;
      } else {
        this.search = this.searchValue;
      }
    },
    sortBy: function sortBy(sortKey) {
      this.reverse = this.sortKey === sortKey ? !this.reverse : false;
      this.sortKey = sortKey;
    },
    updatePageContent: function updatePageContent(content) {
      this.pageContent = content;
    },
    highlight: function highlight(words, query) {
      var iQuery = new RegExp(query, 'ig');
      return words.toString().replace(iQuery, function (matchedTxt) {
        return '<span class="highlight">' + matchedTxt + '</span>';
      });
    },
    updateResultsCount: function updateResultsCount(ev) {
      this.searchResultsCount = ev;
    }
  },
  computed: {
    filteredList: function filteredList() {
      var filtered = this.list;
      if (this.search !== '') {
        var pattern = new RegExp(this.search, 'i');
        filtered = filtered.filter(function (item) {
          return item.firstname.match(pattern) || item.lastname.match(pattern) || item.reference.match(pattern);
        });
      }
      this.filteredCount = filtered.length;
      return filtered;
    },
    request: function request() {
      return this.requestParams;
    },
    noContent: function noContent() {
      return !(this.pageContent instanceof Array && this.pageContent.length);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.searchValue) {
        vm.requestUpdateForce++;
      }
    });
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_ranges__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_date_ranges__["a" /* default */]],
  components: { Paginator: __WEBPACK_IMPORTED_MODULE_1__reusable_paginator_Paginator_vue___default.a },
  name: 'return-list',
  data: function data() {
    return {
      list: [],
      defaultPerPage: { name: 3, value: 3 },
      itemsPerPage: [{ name: 3, value: 3 }, { name: 6, value: 6 }, { name: 12, value: 12 }, { name: 24, value: 24 }, { name: 48, value: 48 }],
      currentPerPage: 3,
      pageContent: [],
      filteredCount: 1,
      fList: null,
      filterByStates: [],
      defaultByStates: {},
      /* table sort functionality */
      sortKey: 'name',

      reverse: false,

      searchValue: '',
      search: '',

      columns: {},

      paginatorPassive: true,
      requestParams: {
        route: 'return-list',
        params: {}
      },
      requestUpdateForce: 1,
      // filter by stores
      storesFilter: [],
      storesDefaultFilter: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.columns = {
      'reference': this.$tr('Nr zamówienia', 'ReturnList'),
      'firstname': this.$tr('Imię i nazwisko', 'ReturnList'),
      'store': this.$tr('Sklep', 'ReturnList'),
      'data': this.$tr('Dane do przelewu', 'ReturnList'),
      'amount': this.$tr('Kwota zwrotu', 'ReturnList'),
      'notes': this.$tr('Uwagi', 'ReturnList'),
      'status': this.$tr('Status', 'ReturnList')
    };
    var def = {
      name: this.$tr('Wszystko', 'ReturnList'),
      value: null
    };
    this.filterByStates.push(def);
    this.defaultByStates = def;
    this.$http.get(this.$router.options.getApiRoute('return-states')).then(function (r) {
      var statesFilters = r.body.states.map(function (el, key) {
        return {
          name: el,
          value: el
        };
      });
      _this.filterByStates = _this.filterByStates.concat(statesFilters);
    });
    var initialStoreFilter = {
      name: this.$tr('--', 'ReturnList'),
      value: null
    };
    this.storesDefaultFilter = initialStoreFilter;
    this.storesFilter.push(initialStoreFilter);
    this.$http.get(this.$router.options.getApiRoute('return-stores')).then(function (resp) {
      if (resp.ok) {
        var storesFilter = resp.body.stores.map(function (el, key) {
          return {
            name: el.name,
            value: el
          };
        });
        _this.storesFilter = _this.storesFilter.concat(storesFilter);
      }
    });
  },

  methods: {
    changePerPage: function changePerPage(ev) {
      this.currentPerPage = ev;
    },
    changeFilterByState: function changeFilterByState(val) {
      if (val !== null) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.requestParams.params['filter']) !== 'object') {
          this.requestParams.params['filter'] = {};
        }
        this.requestParams.params.filter['status'] = val;
      } else {
        if (typeof this.requestParams.params['filter'] !== 'undefined' && typeof this.requestParams.params['filter']['status'] !== 'undefined') {
          delete this.requestParams.params['filter']['status'];
        }
      }
      this.requestUpdateForce++;
    },
    changeFilterByStore: function changeFilterByStore(val) {
      if (val !== null) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.requestParams.params['filter']) !== 'object') {
          this.requestParams.params['filter'] = {};
        }
        this.requestParams.params.filter['shop'] = val;
      } else {
        if (typeof this.requestParams.params['filter'] !== 'undefined' && typeof this.requestParams.params['filter']['shop'] !== 'undefined') {
          delete this.requestParams.params['filter']['shop'];
        }
      }
      this.requestUpdateForce++;
      console.log(val);
    },
    changeDateRange: function changeDateRange(val) {
      if (val !== null) {
        var to = new Date(Date.now());
        to.setSeconds(59);
        to.setMinutes(59);
        to.setHours(23);
        this.requestParams.params['date_from'] = val;
        this.requestParams.params['date_to'] = to.toISOString();
      } else {
        if (typeof this.requestParams.params['date_from'] !== 'undefined') {
          delete this.requestParams.params['date_from'];
        }
        if (typeof this.requestParams.params['date_to'] !== 'undefined') {
          delete this.requestParams.params['date_to'];
        }
      }
      this.requestUpdateForce++;
      console.log(val);
    },
    searchAction: function searchAction() {
      if (this.paginatorPassive) {
        if (this.searchValue !== '') {
          this.requestParams.params['query'] = this.searchValue;
        } else {
          delete this.requestParams.params['query'];
        }
        this.requestUpdateForce++;
      } else {
        this.search = this.searchValue;
      }
    },
    sortBy: function sortBy(sortKey) {
      this.reverse = this.sortKey === sortKey ? !this.reverse : false;
      this.sortKey = sortKey;
    },
    updatePageContent: function updatePageContent(content) {
      this.pageContent = content;
    },
    highlight: function highlight(words, query) {
      var iQuery = new RegExp(query, 'ig');
      return words.toString().replace(iQuery, function (matchedTxt) {
        return '<span class="highlight">' + matchedTxt + '</span>';
      });
    }
  },
  computed: {
    filteredList: function filteredList() {
      var filtered = this.list;
      if (this.search !== '') {
        var pattern = new RegExp(this.search, 'i');
        filtered = filtered.filter(function (item) {
          return item.firstname.match(pattern) || item.lastname.match(pattern) || item.reference.match(pattern);
        });
      }
      this.filteredCount = filtered.length;
      return filtered;
    },
    request: function request() {
      return this.requestParams;
    },
    noContent: function noContent() {
      return !(this.pageContent instanceof Array && this.pageContent.length);
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Paginator: __WEBPACK_IMPORTED_MODULE_0__reusable_paginator_Paginator_vue___default.a },
  name: 'shop-list',
  data: function data() {
    return {
      list: [],
      defaultPerPage: { name: 3, value: 3 },
      itemsPerPage: [{ name: 3, value: 3 }, { name: 6, value: 6 }, { name: 12, value: 12 }, { name: 24, value: 24 }, { name: 48, value: 48 }],
      currentPerPage: 3,
      displayOptions: null,
      displayOptionCurrent: null,
      pageContent: [],
      filteredCount: 1,
      fList: null,
      /* table sort functionality */
      sortKey: 'name',

      reverse: false,

      searchValue: '',
      search: '',

      columns: {},

      paginatorPassive: true,
      requestParams: {
        route: 'shop',
        params: {}
      },
      requestUpdateForce: 1,
      activeListing: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.columns = {
      'name': this.$tr('Nazwa sklepu', 'ShopList'),
      'code': this.$tr('Kod', 'ShopList'),
      'orders': this.$tr('Zamówienia', 'ShopList'),
      'settings': this.$tr('Ustawienia', 'ShopList')
    };
    this.displayOptions = [{ name: this.$tr('alfabetycznie A-Z', 'ShopList'), value: 'name-ASC' }, { name: this.$tr('alfabetycznie Z-A', 'ShopList'), value: 'name-DESC' }, { name: this.$tr('od najnowszych', 'ShopList'), value: 'code-ASC' }, { name: this.$tr('od najstarszych', 'ShopList'), value: 'code-DESC' }];
    this.displayOptionCurrent = { name: this.$tr('alfabetycznie A-Z', 'ShopList'), value: 'name-ASC' };

    this.$http.get(this.$router.options.getApiRoute('shop')).then(function (r) {
      _this.list = r.body;
      _this.filteredCount = _this.list.length;
      console.log(_this.list);
    });
    this.sortBy(this.displayOptionCurrent.value);
  },

  methods: {
    changePerPage: function changePerPage(ev) {
      this.currentPerPage = ev;
      console.log(ev);
    },
    searchAction: function searchAction() {
      if (this.paginatorPassive) {
        if (this.searchValue !== '') {
          this.requestParams.params['query'] = this.searchValue;
          this.activeListing = true;
        } else {
          delete this.requestParams.params['query'];
          this.activeListing = false;
        }
        this.requestUpdateForce++;
      } else {
        this.search = this.searchValue;
      }
    },

    /* sort value must be made from ORDER_KEY-ORDER_WAY - where '-' is delimiter */
    sortBy: function sortBy(sortKey) {
      var value = sortKey.split('-');
      if (sortKey.indexOf('-') === -1) {
        console.log('Wrong sort value. It must be in format: ORDER_KEY-ORDER_WAY - where \'-\' is delimiter');
        if (typeof this.requestParams.params['order_by'] !== 'undefined') {
          delete this.requestParams.params['order_by'];
        }
        if (typeof this.requestParams.params['order_way'] !== 'undefined') {
          delete this.requestParams.params['order_way'];
        }
      } else {
        this.requestParams.params['order_by'] = value[0];
        this.requestParams.params['order_way'] = value[1];
      }
      this.requestUpdateForce++;
      console.log(value);
    },
    updatePageContent: function updatePageContent(content) {
      this.pageContent = content;
    },
    highlight: function highlight(words, query) {
      var iQuery = new RegExp(query, 'ig');
      return words.toString().replace(iQuery, function (matchedTxt) {
        return '<span class="highlight">' + matchedTxt + '</span>';
      });
    },
    updateShop: function updateShop(shop) {
      var _this2 = this;

      console.log(shop);
      this.$http.post(this.$router.options.getApiRoute('shop-settings', { code: shop.code }), {
        shop: shop
      }).then(function (resp) {
        if (resp.ok) {
          _this2.$alertify.notify(_this2.$tr('Zaktualizowano pomyślnie', 'ShopList'), 'success', 3);
        } else {
          if (typeof resp.body.errors !== 'undefined' && resp.body.errors.length > 0) {
            for (var e in resp.body.errors) {
              _this2.$alertify.notify(resp.body.errors[e], 'warning', 3);
            }
          }
        }
      }, function (resp) {
        console.log('fail:');
        console.log(resp);
      });
    }
  },
  computed: {
    filteredList: function filteredList() {
      var filtered = this.list;
      if (this.search !== '') {
        var pattern = new RegExp(this.search, 'i');
        filtered = filtered.filter(function (item) {
          return item.firstname.match(pattern) || item.lastname.match(pattern) || item.reference.match(pattern);
        });
      }
      this.filteredCount = filtered.length;
      return filtered;
    },
    request: function request() {
      return this.requestParams;
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'shop-settings',
  data: function data() {
    return {
      notFound: false,
      isNew: false,
      shop: {
        address: {
          street: '',
          address: '',
          address1: '',
          address2: '',
          postcode: ''
        },
        name: '',
        code: 0,
        email: '',
        can_return: false,
        can_collect: false
      },
      password: '',
      confirmation: '',
      confirmationBlurred: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (typeof this.$route.params.code !== 'undefined') {
      if (this.$route.params.code === 'new') {
        this.isNew = true;
      } else {
        this.$http.get(this.$router.options.getApiRoute('shop-settings', { code: this.$route.params.code })).then(function (resp) {
          if (typeof resp.body[0] !== 'undefined') {
            console.log(resp.body[0]);
            _this.shop = resp.body[0];
            _this.notFound = false;
          } else {
            _this.notFound = true;
          }
        }, function (resp) {
          console.log(resp.body);
          _this.notFound = true;
        });
      }
    }
  },

  methods: {
    pushShop: function pushShop() {
      var _this2 = this;

      this.$validator.validateAll({
        name: this.shop.name,
        address_street: this.shop.address.street,
        address_house: this.shop.address.house,
        address_flat: this.shop.address.flat,
        address_postcode: this.shop.address.postcode,
        email: this.shop.email,
        password: this.password,
        confirmation: this.confirmation
      }).then(function (result) {
        if (result) {
          _this2.$http.post(_this2.$router.options.getApiRoute('shop-settings', { code: _this2.shop.code }), {
            shop: _this2.shop,
            password: _this2.password,
            confirmation: _this2.confirmation
          }).then(function (resp) {
            console.log(resp.body);
            if (resp.ok) {
              _this2.$router.push({ name: 'ShopList' });
            }
          }, function (resp) {
            console.log(resp);
            if (typeof resp.body.errors !== 'undefined' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(resp.body.errors).length > 0) {
              for (var e in resp.body.errors) {
                _this2.$alertify.notify(resp.body.errors[e], 'error', 3);
              }
            }
          });
        } else {
          _this2.$alertify.notify(_this2.$tr('Popraw dane', 'ShopSettings'), 'error', 3);
        }
      }).catch(function () {
        // something went wrong (non-validation related).
        console.log('error to catch');
      });
    }
  },
  computed: {
    //
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dropdown',
  data: function data() {
    return {
      choosedValue: null,
      choosedLabel: null,
      reveal: false
    };
  },

  props: {
    //       asd
    items: Array,
    defaultValue: {
      'default': '--'
    },
    defaultLabel: {
      'default': '--'
    }
  },
  mounted: function mounted() {
    if (this.defaultValue === '--') {
      this.defaultValue = this.$tr('--', 'dropdown');
    }
    if (this.items && typeof this.items[0] !== 'undefined') {
      this.choosedValue = typeof this.items[0].name !== 'undefined' ? this.items[0].name : typeof this.items[0].value !== 'undefined' ? this.items[0].value : this.items[0];
    }
  },

  methods: {
    changeAction: function changeAction(val, lab) {
      console.log();
      this.reveal = false;
      this.choosedLabel = lab;
      this.choosedValue = val;
      this.$emit('change', val);
    }
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/*
* This component takes as properties items (of array), and itemsPerPage.
* It returns chunk of array (page) as parameter of change event callback
* */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'paginator',
  data: function data() {
    return {
      page: 1,
      requestPages: 1,
      pageItems: [],
      beforeDots: false,
      afterDots: false,
      head: 0,
      tail: 0
    };
  },

  props: {
    items: {
      'default': Array
    },
    itemsPerPage: Number,
    spread: {
      type: Number,
      'default': 2
    },
    passiveMode: {
      'default': false
    },
    request: {
      'default': null // it should be object {route: 'endpoint/uri', params: {'param1': 'value1'}}
    },
    updateForce: {
      'default': 1
    },
    active: {
      'default': true
    }
  },
  mounted: function mounted() {
    this.changeAction(1);
  },

  methods: {
    changeAction: function changeAction(val) {
      var _this = this;

      if (!this.active) {
        this.$emit('change', []);
        return;
      }
      if (!this.passiveMode) {
        this.page = val;
        this.head = (this.page - 1) * this.thItemsPerPage;
        this.tail = this.elementsCount - this.page * this.thItemsPerPage;
        var end = this.head + this.thItemsPerPage;
        if (end > this.elementsCount) {
          end = this.elementsCount;
        }
        this.pageItems = this.items.slice(this.head, end);
        this.spreadConditioning();
        this.$emit('change', this.pageItems);
      } else {
        var params = typeof this.request.params === 'undefined' ? {} : this.request.params;
        params['page'] = val;
        params['items_per_page'] = this.itemsPerPage;
        var path = this.$router.options.getApiRoute(this.request.route);
        this.$http.get(path, { params: params }).then(function (resp) {
          if (resp.ok) {
            _this.page = val;
            _this.pageItems = resp.body.items;
            _this.requestPages = resp.body.itemsCount;
            _this.spreadConditioning();
            _this.$emit('change', _this.pageItems);
            _this.$emit('results-count', _this.requestPages);
          }
        }, function (resp) {
          _this.$helper.stdErrors(resp);
        });
      }
    },
    spreadConditioning: function spreadConditioning() {
      this.beforeDots = this.page - this.spread > this.spread;
      this.afterDots = Number(this.page) + Number(this.spread) + 1 < this.pagesCount;
    }
  },
  computed: {
    pagesCount: function pagesCount() {
      return Math.ceil(this.elementsCount / this.thItemsPerPage);
    },
    elementsCount: function elementsCount() {
      if (this.passiveMode) {
        return this.requestPages;
      } else {
        return this.items.length;
      }
    },
    thItemsPerPage: function thItemsPerPage() {
      return this.itemsPerPage;
    }
  },
  watch: {
    itemsPerPage: function itemsPerPage() {
      this.changeAction(1);
    },
    items: function items() {
      this.changeAction(1);
    },
    updateForce: function updateForce() {
      if (this.passiveMode) {
        console.log('request params changed');
        this.changeAction(1);
      }
    }
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'radio',
  data: function data() {
    return {
      debug: false,
      choosedValue: null,
      reveal: false,
      variantClass: null
    };
  },

  props: {
    items: Array,
    variant: {
      type: String,
      'default': 'button',
      validator: function validator(value) {
        var allowedValues = ['button', 'check'];
        return allowedValues.indexOf(value) !== -1;
      }
    },
    disabled: {
      type: Boolean,
      'default': false
    },
    initialValue: {
      'default': null
    }
  },
  mounted: function mounted() {
    this.variantClass = 'om-radio--' + this.variant;
    if (this.initialValue !== null) {
      this.choosedValue = this.initialValue;
    } else if (typeof this.items !== 'undefined' && this.items !== null && typeof this.items[0] !== 'undefined') {
      this.choosedValue = typeof this.items[0].name !== 'undefined' ? this.items[0].name : typeof this.items[0].value !== 'undefined' ? this.items[0].value : this.items[0];
    }
  },

  methods: {
    changeAction: function changeAction(val) {
      if (this.disabled) {
        return false;
      }
      this.reveal = false;
      if (this.choosedValue !== val) {
        this.choosedValue = val;
      } else {
        this.choosedValue = null;
      }
      if (this.debug) console.log(this.choosedValue);
      this.$emit('change', this.choosedValue);
    }
  }
});

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 50,
	"./af.js": 50,
	"./ar": 57,
	"./ar-dz": 51,
	"./ar-dz.js": 51,
	"./ar-kw": 52,
	"./ar-kw.js": 52,
	"./ar-ly": 53,
	"./ar-ly.js": 53,
	"./ar-ma": 54,
	"./ar-ma.js": 54,
	"./ar-sa": 55,
	"./ar-sa.js": 55,
	"./ar-tn": 56,
	"./ar-tn.js": 56,
	"./ar.js": 57,
	"./az": 58,
	"./az.js": 58,
	"./be": 59,
	"./be.js": 59,
	"./bg": 60,
	"./bg.js": 60,
	"./bm": 61,
	"./bm.js": 61,
	"./bn": 63,
	"./bn-bd": 62,
	"./bn-bd.js": 62,
	"./bn.js": 63,
	"./bo": 64,
	"./bo.js": 64,
	"./br": 65,
	"./br.js": 65,
	"./bs": 66,
	"./bs.js": 66,
	"./ca": 67,
	"./ca.js": 67,
	"./cs": 68,
	"./cs.js": 68,
	"./cv": 69,
	"./cv.js": 69,
	"./cy": 70,
	"./cy.js": 70,
	"./da": 71,
	"./da.js": 71,
	"./de": 74,
	"./de-at": 72,
	"./de-at.js": 72,
	"./de-ch": 73,
	"./de-ch.js": 73,
	"./de.js": 74,
	"./dv": 75,
	"./dv.js": 75,
	"./el": 76,
	"./el.js": 76,
	"./en-au": 77,
	"./en-au.js": 77,
	"./en-ca": 78,
	"./en-ca.js": 78,
	"./en-gb": 79,
	"./en-gb.js": 79,
	"./en-ie": 80,
	"./en-ie.js": 80,
	"./en-il": 81,
	"./en-il.js": 81,
	"./en-in": 82,
	"./en-in.js": 82,
	"./en-nz": 83,
	"./en-nz.js": 83,
	"./en-sg": 84,
	"./en-sg.js": 84,
	"./eo": 85,
	"./eo.js": 85,
	"./es": 89,
	"./es-do": 86,
	"./es-do.js": 86,
	"./es-mx": 87,
	"./es-mx.js": 87,
	"./es-us": 88,
	"./es-us.js": 88,
	"./es.js": 89,
	"./et": 90,
	"./et.js": 90,
	"./eu": 91,
	"./eu.js": 91,
	"./fa": 92,
	"./fa.js": 92,
	"./fi": 93,
	"./fi.js": 93,
	"./fil": 94,
	"./fil.js": 94,
	"./fo": 95,
	"./fo.js": 95,
	"./fr": 98,
	"./fr-ca": 96,
	"./fr-ca.js": 96,
	"./fr-ch": 97,
	"./fr-ch.js": 97,
	"./fr.js": 98,
	"./fy": 99,
	"./fy.js": 99,
	"./ga": 100,
	"./ga.js": 100,
	"./gd": 101,
	"./gd.js": 101,
	"./gl": 102,
	"./gl.js": 102,
	"./gom-deva": 103,
	"./gom-deva.js": 103,
	"./gom-latn": 104,
	"./gom-latn.js": 104,
	"./gu": 105,
	"./gu.js": 105,
	"./he": 106,
	"./he.js": 106,
	"./hi": 107,
	"./hi.js": 107,
	"./hr": 108,
	"./hr.js": 108,
	"./hu": 109,
	"./hu.js": 109,
	"./hy-am": 110,
	"./hy-am.js": 110,
	"./id": 111,
	"./id.js": 111,
	"./is": 112,
	"./is.js": 112,
	"./it": 114,
	"./it-ch": 113,
	"./it-ch.js": 113,
	"./it.js": 114,
	"./ja": 115,
	"./ja.js": 115,
	"./jv": 116,
	"./jv.js": 116,
	"./ka": 117,
	"./ka.js": 117,
	"./kk": 118,
	"./kk.js": 118,
	"./km": 119,
	"./km.js": 119,
	"./kn": 120,
	"./kn.js": 120,
	"./ko": 121,
	"./ko.js": 121,
	"./ku": 122,
	"./ku.js": 122,
	"./ky": 123,
	"./ky.js": 123,
	"./lb": 124,
	"./lb.js": 124,
	"./lo": 125,
	"./lo.js": 125,
	"./lt": 126,
	"./lt.js": 126,
	"./lv": 127,
	"./lv.js": 127,
	"./me": 128,
	"./me.js": 128,
	"./mi": 129,
	"./mi.js": 129,
	"./mk": 130,
	"./mk.js": 130,
	"./ml": 131,
	"./ml.js": 131,
	"./mn": 132,
	"./mn.js": 132,
	"./mr": 133,
	"./mr.js": 133,
	"./ms": 135,
	"./ms-my": 134,
	"./ms-my.js": 134,
	"./ms.js": 135,
	"./mt": 136,
	"./mt.js": 136,
	"./my": 137,
	"./my.js": 137,
	"./nb": 138,
	"./nb.js": 138,
	"./ne": 139,
	"./ne.js": 139,
	"./nl": 141,
	"./nl-be": 140,
	"./nl-be.js": 140,
	"./nl.js": 141,
	"./nn": 142,
	"./nn.js": 142,
	"./oc-lnc": 143,
	"./oc-lnc.js": 143,
	"./pa-in": 144,
	"./pa-in.js": 144,
	"./pl": 145,
	"./pl.js": 145,
	"./pt": 147,
	"./pt-br": 146,
	"./pt-br.js": 146,
	"./pt.js": 147,
	"./ro": 148,
	"./ro.js": 148,
	"./ru": 149,
	"./ru.js": 149,
	"./sd": 150,
	"./sd.js": 150,
	"./se": 151,
	"./se.js": 151,
	"./si": 152,
	"./si.js": 152,
	"./sk": 153,
	"./sk.js": 153,
	"./sl": 154,
	"./sl.js": 154,
	"./sq": 155,
	"./sq.js": 155,
	"./sr": 157,
	"./sr-cyrl": 156,
	"./sr-cyrl.js": 156,
	"./sr.js": 157,
	"./ss": 158,
	"./ss.js": 158,
	"./sv": 159,
	"./sv.js": 159,
	"./sw": 160,
	"./sw.js": 160,
	"./ta": 161,
	"./ta.js": 161,
	"./te": 162,
	"./te.js": 162,
	"./tet": 163,
	"./tet.js": 163,
	"./tg": 164,
	"./tg.js": 164,
	"./th": 165,
	"./th.js": 165,
	"./tk": 166,
	"./tk.js": 166,
	"./tl-ph": 167,
	"./tl-ph.js": 167,
	"./tlh": 168,
	"./tlh.js": 168,
	"./tr": 169,
	"./tr.js": 169,
	"./tzl": 170,
	"./tzl.js": 170,
	"./tzm": 172,
	"./tzm-latn": 171,
	"./tzm-latn.js": 171,
	"./tzm.js": 172,
	"./ug-cn": 173,
	"./ug-cn.js": 173,
	"./uk": 174,
	"./uk.js": 174,
	"./ur": 175,
	"./ur.js": 175,
	"./uz": 177,
	"./uz-latn": 176,
	"./uz-latn.js": 176,
	"./uz.js": 177,
	"./vi": 178,
	"./vi.js": 178,
	"./x-pseudo": 179,
	"./x-pseudo.js": 179,
	"./yo": 180,
	"./yo.js": 180,
	"./zh-cn": 181,
	"./zh-cn.js": 181,
	"./zh-hk": 182,
	"./zh-hk.js": 182,
	"./zh-mo": 183,
	"./zh-mo.js": 183,
	"./zh-tw": 184,
	"./zh-tw.js": 184
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(282),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-90960cf0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(280),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4fed48a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(283),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9cd93b3e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(278),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a1c6287",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(281),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5463ee53",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(288),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa872e76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(277),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04c37285",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(286),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ed05c3ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(279),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3396ec90",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(276),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(285),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "om-dropdown"
  }, [_c('div', {
    staticClass: "om-dropdown__label",
    class: {
      'is-open': _vm.reveal
    },
    on: {
      "click": function($event) {
        _vm.reveal = !_vm.reveal
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.choosedLabel ? _vm.choosedLabel : _vm.defaultLabel) + "\n  ")]), _vm._v(" "), (_vm.reveal) ? _c('div', {
    staticClass: "om-dropdown__clickout",
    on: {
      "click": function($event) {
        _vm.reveal = !_vm.reveal
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.reveal) ? _c('ul', {
    staticClass: "om-dropdown__list"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "om-dropdown__item",
      class: {
        'active': _vm.choosedValue === item.value
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeAction(item.value, typeof item.name !== 'undefined' ? item.name : item.value)
        }
      }
    }, [(typeof item.name !== 'undefined') ? _c('span', {
      staticClass: "a"
    }, [_vm._v(_vm._s(item.name))]) : (typeof item.value !== 'undefined') ? _c('span', {
      staticClass: "b"
    }, [_vm._v(_vm._s(item.value))]) : _vm._e()])
  }), 0) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_c('label', {
    attrs: {
      "for": "search"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Lista zwrotów', 'ReturnList')))])]), _vm._v(" "), _c('form', {
    staticClass: "om-search flex sb"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "om-search__input fg-20",
    attrs: {
      "id": "search",
      "placeholder": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'ReturnList'),
      "title": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'ReturnList')
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "om-btn om-search__submit",
    attrs: {
      "placeholder": _vm.$tr('', 'ReturnList'),
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$tr('Szukaj', 'ReturnList')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading flex sb"
  }, [(_vm.search != '') ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--bright"
  }, [_vm._v(_vm._s(_vm.$tr('Wyniki wyszukiwania:', 'ReturnList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.search))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--num"
  }, [_vm._v("(" + _vm._s(_vm.filteredCount) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Pokaż', 'ReturnList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.itemsPerPage,
      "default-label": _vm.defaultPerPage.name,
      "default-value": _vm.defaultPerPage.value
    },
    on: {
      "change": _vm.changePerPage
    }
  })], 1), _vm._v(" "), (_vm.storesDefaultFilter) ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Sklep', 'ReturnList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.storesFilter,
      "default-label": _vm.storesDefaultFilter.name,
      "default-value": _vm.storesDefaultFilter.value
    },
    on: {
      "change": _vm.changeFilterByStore
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('radio', {
    attrs: {
      "items": _vm.dateRangesFilter
    },
    on: {
      "change": _vm.changeDateRange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Wyświetl:', 'ReturnList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.filterByStates,
      "default-label": _vm.defaultByStates.name,
      "default-value": _vm.defaultByStates.value
    },
    on: {
      "change": _vm.changeFilterByState
    }
  })], 1)], 1), _vm._v(" "), (!_vm.noContent) ? _c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.columns.reference))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.firstname))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.store))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.data))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.amount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.notes))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.status))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageContent), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "reference"
    }, [_vm._v(_vm._s(item.reference))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "font-normal",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.firstname + ' ' + item.lastname, _vm.search))
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.phone))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(typeof item.store_return !== 'undefined' ? item.store_return.name : ''))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(item.payment_info)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "total"
    }, [_vm._v(_vm._s(item.total_return) + " " + _vm._s(item.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.notes))]), _vm._v(" "), _c('td', {
      staticClass: "status",
      style: ({
        color: item.statusColor
      })
    }, [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('td', {
      staticClass: "more"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Return',
          params: {
            reference: item.reference
          }
        }
      }
    }, [_c('i', {
      staticClass: "om-ico-zoom",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), 0)]) : _c('div', {
    staticClass: "om-information"
  }, [_vm._v("\n    " + _vm._s(_vm.$tr('Brak wyników. Spróbuj zmienić parametry wyszukiwania.', 'ReturnList')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "om-list-footer flex sb"
  }, [_c('div'), _vm._v(" "), _c('paginator', {
    attrs: {
      "items-per-page": _vm.currentPerPage,
      "passive-mode": _vm.paginatorPassive,
      "request": _vm.request,
      "update-force": _vm.requestUpdateForce
    },
    on: {
      "change": _vm.updatePageContent
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loggedShop) ? _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_vm._v("\n    " + _vm._s((!_vm.order || !_vm.order.collected) ? _vm.$tr('Odbiór zamówienia', 'Order') : _vm.$tr('Zwrot zamówienia', 'Order')) + "\n    "), _c('router-link', {
    staticClass: "om-link-back",
    attrs: {
      "to": {
        name: (this.$route.name == 'Collect' ? 'CollectList' : 'OrderList')
      }
    }
  }, [_c('i', {
    staticClass: "om-ico-back-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$tr('wróć', 'Order')) + "\n    ")])], 1), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "om-order"
  }, [_c('ul', {
    staticClass: "om-order__general"
  }, [_c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Zamówienie:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.reference) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Imię i nazwisko:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.firstname + ' ' + _vm.order.lastname) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Telefon:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.phone) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Adres e-mail:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.email) + "\n      ")]), _vm._v(" "), (_vm.order.store_collect && _vm.order.store_collect.name) ? _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Miejsce odbioru:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-order__val"
  }, [_c('div', [_vm._v(_vm._s(_vm.order.store_collect.name))]), _vm._v(" "), (_vm.order.store_collect.address) ? _c('div', [_c('div', [_vm._v(_vm._s(_vm.$tr('ul.', 'Order')) + " " + _vm._s(_vm.order.store_collect.address.street) + " " + _vm._s(_vm.order.store_collect.address.flat ? ((_vm.order.store_collect.address.house) + "/" + (_vm.order.store_collect.address.flat)) : ("" + (_vm.order.store_collect.address.house))))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.store_collect.address.postcode) + " " + _vm._s(_vm.order.store_collect.address.city))])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.order.products) ? _c('div', {
    staticClass: "om-products"
  }, [_c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$tr('Produkty', 'Order')) + " (" + _vm._s(_vm.order.products.length) + ")")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$tr('Cena jednostkowa (brutto)', 'Order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$tr('Ilość', 'Order')))]), _vm._v(" "), (_vm.order.collected) ? _c('th', [_vm._v("\n              " + _vm._s(_vm.$tr('Ilość zwracanych produktów', 'Order')) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.order.products), function(p, k) {
    return _c('tr', {
      key: k
    }, [_c('td', [_c('div', {
      staticClass: "flex cen"
    }, [_c('div', {
      staticClass: "om-products__image"
    }, [_c('img', {
      attrs: {
        "src": p.image,
        "alt": p.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "om-products__desc fg-20"
    }, [_c('h4', {
      staticClass: "om-products__medium"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('h5', {
      staticClass: "om-products__small"
    }, [_vm._v(_vm._s(_vm.$tr('Kod produktu:', 'Order')) + " " + _vm._s(p.reference))]), _vm._v(" "), (p.attributes) ? _c('ul', {
      staticClass: "om-attributes"
    }, _vm._l((p.attributes), function(a, k) {
      return _c('li', {
        key: k,
        staticClass: "om-products__small"
      }, [_vm._v("\n                      " + _vm._s(k) + ": " + _vm._s(a) + "\n                    ")])
    }), 0) : _vm._e()])])]), _vm._v(" "), _c('td', {
      staticClass: "om-std"
    }, [_vm._v(_vm._s(p.price) + " "), _c('span', {
      staticClass: "currency"
    }, [_vm._v(_vm._s(p.currency))])]), _vm._v(" "), _c('td', {
      staticClass: "om-std"
    }, [_vm._v(_vm._s(p.quantity))]), _vm._v(" "), (_vm.order.collected && p.quantity - p.quantity_returned > 0) ? _c('td', {
      staticClass: "om-std"
    }, [_c('input', {
      staticClass: "om-input--qty",
      attrs: {
        "type": "text"
      },
      on: {
        "keyup": function($event) {
          $event.preventDefault();
          return _vm.orderReturnModify($event, p)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "om-slash"
    }, [_vm._v("/")]), _vm._v(" " + _vm._s(p.quantity - p.quantity_returned) + "\n            ")]) : (_vm.order.collected) ? _c('td', [_vm._v("\n              " + _vm._s(_vm.$tr('zwrócono wszystkie', 'Order')) + "\n            ")]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  }), _vm._v(" "), (_vm.anyDocumentsAvailable) ? _c('div', [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Dokumenty do pobrania:', 'Order')) + "\n      ")]), _vm._v(" "), (_vm.collectPDFCanBeDisplayed) ? _c('div', [_c('div', {
    staticClass: "om-pdf-link__line"
  }, [_c('button', {
    staticClass: "om-pdf-link",
    on: {
      "click": function($event) {
        return _vm.downloadCollectPDF($event, _vm.order.reference)
      }
    }
  }, [_c('i', {
    staticClass: "om-ico-file-pdf-o om-pdf-link__ico",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$tr("Potwierdzenie odbioru", 'Order')) + "\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.returnPDFCanBeDisplayed) ? _c('div', _vm._l((_vm.order.returns_pdf), function(code, k) {
    return _c('div', {
      key: k,
      staticClass: "om-pdf-link__line"
    }, [_c('button', {
      staticClass: "om-pdf-link",
      on: {
        "click": function($event) {
          return _vm.downloadReturnPDF($event, code)
        }
      }
    }, [_c('i', {
      staticClass: "om-ico-file-pdf-o om-pdf-link__ico",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n            " + _vm._s(_vm.$tr("Potwierdzenie zwrotu ", 'Order')) + " " + _vm._s(code) + "\n          ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  })]) : _vm._e(), _vm._v(" "), (!_vm.order.collected) ? _c('div', {
    staticClass: "om-order-state"
  }, [(typeof _vm.order.store_collect_details !== 'undefined' && _vm.order.store_collect_details.code !== _vm.loggedShop.code) ? _c('div', [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Zamówienie do odebrania w sklepie:', 'Order')) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.store_collect_details.name))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.$tr('ul.', 'ShopList')) + " " + _vm._s(_vm.order.store_collect_details.address.street) + "\n          " + _vm._s(_vm.order.store_collect_details.address.house) + "\n          " + _vm._s(typeof _vm.order.store_collect_details.address.flat !== 'undefined' && _vm.order.store_collect_details.address.flat !== '' ? ("/ " + (_vm.order.store_collect_details.address.flat)) : '') + "\n        ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.store_collect_details.address.postcode) + " " + _vm._s(_vm.order.store_collect_details.address.city))])]) : _c('div', [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Status odbioru', 'Order')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex cen"
  }, [_c('label', {
    staticClass: "om-dropdown__title"
  }, [_vm._v(_vm._s(_vm.$tr('Zamówienie:', 'Order')))]), _vm._v(" "), (_vm.states) ? _c('dropdown', {
    attrs: {
      "items": _vm.states,
      "default-label": _vm.defaultState ? _vm.defaultState.name : _vm.$tr('Wybierz', 'Order'),
      "default-value": _vm.defaultState ? _vm.defaultState.value : 0
    },
    on: {
      "change": _vm.changeChoosedState
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex h-cen"
  }, [_c('button', {
    staticClass: "om-btn om-btn--medium om-btn--update",
    attrs: {
      "id": "cta-push-order-state"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pushOrderState()
      }
    }
  }, [_vm._v(_vm._s(_vm.$tr('Aktualizuj status', 'Order')))])])])]) : _c('div', [(_vm.loggedShop.can_return) ? _c('div', {
    staticClass: "flex sb wrap"
  }, [_c('div', {
    staticClass: "om-col-8"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n            " + _vm._s(_vm.$tr('Podsumowanie zwrotu:', 'Order')) + "\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "om-summary"
  }, [_c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Nazwy produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._l((_vm.returnProducts), function(prod, i, k) {
    return _c('span', {
      key: i
    }, [_vm._v("\n                " + _vm._s(prod.name) + _vm._s(Object.keys(_vm.returnProducts).length > k + 1 ? ',' : '') + "\n              ")])
  }), _vm._v(" "), (!Object.keys(_vm.returnProducts).length) ? _c('span', [_vm._v("-")]) : _vm._e()], 2)]), _vm._v(" "), _c('li', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Ilość zwróconych produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.returnSummary.quantity))])]), _vm._v(" "), _c('li', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Wartość zwróconych produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$helper.displayPrice(_vm.returnSummary.value, _vm.returnSummary.currency)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "om-col-4"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Uwagi:', 'Order')) + " "), _c('span', {
    staticClass: "om-subheading__small"
  }, [_vm._v(_vm._s(_vm.$tr('(opcjonalnie)', 'Order')))])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "om-textarea",
    attrs: {
      "name": "message",
      "id": "message",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex h-cen fg-20"
  }, [_c('button', {
    staticClass: "om-btn om-btn--medium om-btn--update",
    attrs: {
      "id": "cta-push-return"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pushReturn()
      }
    }
  }, [_vm._v(_vm._s(_vm.$tr('Dokonaj zwrotu', 'Order')))])])]) : _c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Ten sklep nie może dokonywać zwrotów', 'Order')) + "\n      ")])]), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  })]) : (_vm.notFound) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.$tr('Brak szczegółów zamówienia', 'Order')) + "\n  ")]) : _c('div')]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_vm._v("\n    " + _vm._s(_vm.isNew ? _vm.$tr('Dodawanie nowego sklepu', 'ShopSettings') : _vm.$tr('Edytuj dane sklepu', 'ShopSettings')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "om-form",
    attrs: {
      "data-vv-scope": "shop-form"
    }
  }, [_c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-name"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Nazwa sklepu:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.name),
      expression: "shop.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^[\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\-]*$/
        }
      }),
      expression: "{ rules: { required: true, regex: /^[\\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\\-]*$/} }"
    }],
    attrs: {
      "title": _vm.$tr('nazwa sklepu', 'ShopSettings'),
      "id": "in-name",
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.shop.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('name')) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group flex"
  }, [_c('label', {
    attrs: {
      "for": "in-address-street"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Adres sklepu:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap om-form__input-wrap--street fg-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.street),
      expression: "shop.address.street"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^[\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\-]*$/
        }
      }),
      expression: "{ rules: { required: true, regex: /^[\\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\\-]*$/} }"
    }],
    attrs: {
      "title": _vm.$tr('adres sklepu', 'ShopSettings'),
      "id": "in-address-street",
      "type": "text",
      "name": "address_street"
    },
    domProps: {
      "value": (_vm.shop.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "street", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap om-form__input-wrap--house"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.house),
      expression: "shop.address.house"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          regex: /^[0-9A-z]+$/
        }
      }),
      expression: "{ rules: { regex: /^[0-9A-z]+$/} }"
    }],
    attrs: {
      "title": _vm.$tr('nr budynku', 'ShopSettings'),
      "id": "in-address-house",
      "type": "text",
      "name": "address_house"
    },
    domProps: {
      "value": (_vm.shop.address.house)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "house", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-slash"
  }), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap om-form__input-wrap--flat"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.flat),
      expression: "shop.address.flat"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          regex: /^[0-9A-z]+$/
        }
      }),
      expression: "{ rules: { regex: /^[0-9A-z]+$/} }"
    }],
    attrs: {
      "title": _vm.$tr('nr lokalu', 'ShopSettings'),
      "id": "in-address-flat",
      "type": "text",
      "name": "address_flat"
    },
    domProps: {
      "value": (_vm.shop.address.flat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "flat", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('address_street')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_street')))]) : (_vm.errors.has('address_house')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_house')))]) : (_vm.errors.has('address_flat')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_flat')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-address-postcode"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Kod pocztowy:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap om-form__input-wrap--postcode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.postcode),
      expression: "shop.address.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^([0-9]{2}-[0-9]{3})$/
        }
      }),
      expression: "{ rules: { required: true, regex: /^([0-9]{2}-[0-9]{3})$/} }"
    }],
    attrs: {
      "title": _vm.$tr('kod pocztowy', 'ShopSettings'),
      "id": "in-address-postcode",
      "type": "text",
      "name": "address_postcode"
    },
    domProps: {
      "value": (_vm.shop.address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group om-form__group--city"
  }, [_c('label', {
    attrs: {
      "for": "in-address-city"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Miasto:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.address.city),
      expression: "shop.address.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^[\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,]*$/
        }
      }),
      expression: "{ rules: { required: true, regex: /^[\\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,]*$/} }"
    }],
    attrs: {
      "title": _vm.$tr('miasto', 'ShopSettings'),
      "id": "in-address-city",
      "type": "text",
      "name": "address_city"
    },
    domProps: {
      "value": (_vm.shop.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop.address, "city", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('address_postcode')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_postcode')))]) : (_vm.errors.has('address_city')) ? _c('div', {
    staticClass: "om-form__group om-error"
  }, [_vm._v(_vm._s(_vm.errors.first('address_city')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-email"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Adres e-mail:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.email),
      expression: "shop.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "title": _vm.$tr('adres e-mail', 'ShopSettings'),
      "id": "in-email",
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.shop.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shop, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('email')) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-password"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Hasło:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "title": _vm.$tr('hasło', 'ShopSettings'),
      "id": "in-password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('password')) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group"
  }, [_c('label', {
    attrs: {
      "for": "in-confirmation"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Powtórz hasło:', 'ShopSettings')))]), _vm._v(" "), _c('div', {
    staticClass: "om-form__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmation),
      expression: "confirmation"
    }],
    attrs: {
      "title": _vm.$tr('powtórz hasło', 'ShopSettings'),
      "id": "in-confirmation",
      "type": "password",
      "name": "confirmation"
    },
    domProps: {
      "value": (_vm.confirmation)
    },
    on: {
      "blur": function($event) {
        _vm.confirmationBlurred = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmation = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.errors.has('confirmation')) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmation')))]) : (_vm.password !== _vm.confirmation) ? _c('div', {
    staticClass: "om-error om-form__group"
  }, [_vm._v(_vm._s(_vm.$tr('Hasła do siebie nie pasują', 'ShopSettings')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "om-form__group"
  }, [_c('button', {
    staticClass: "om-btn om-form__submit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pushShop.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Zapisz zmiany', 'ShopSettings')) + "\n      ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "om-container"
  }, [_c('div', {
    staticClass: "om-login"
  }, [_c('div', {
    staticClass: "om-center om-main-logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "alt": _vm.$tr('OmniWay', 'Login')
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isFormReady) ? _c('form', {
    staticClass: "om-form--login",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.loginAction.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "om-center"
  }, [(_vm.settings && _vm.settings.logo_url) ? _c('img', {
    staticClass: "om-user-logo",
    attrs: {
      "src": _vm.settings.logo_url,
      "alt": _vm.$tr('Logo', 'Login')
    }
  }) : _c('img', {
    staticClass: "om-user-logo",
    attrs: {
      "src": "/static/temp/logo-patrizia-aryton.png",
      "alt": _vm.$tr('Logo', 'Login')
    }
  })]), _vm._v(" "), (_vm.settings) ? _c('h3', {
    staticClass: "om-form--login__heading"
  }, [_vm._v("\n          " + _vm._s(_vm.tr('Zaloguj się do systemu', 'Login')) + "\n          " + _vm._s(_vm.settings.name) + "\n        ")]) : _c('h3', {
    staticClass: "om-form--login__heading"
  }, [_vm._v("\n          " + _vm._s(_vm.tr('Zaloguj się do systemu Aryton Omniway', 'Login')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "om-form--login__group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateRules.username),
      expression: "validateRules.username"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "om-form--login__input--login",
    class: {
      'is-invalid': _vm.errors.has('username'),
      'is-not-empty': _vm.username.length
    },
    attrs: {
      "id": "username",
      "name": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "om-form--login__label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Login', 'Login')))]), _vm._v(" "), _c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/img/icon-person.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-form--login__group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateRules.password),
      expression: "validateRules.password"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "om-form--login__input--login",
    class: {
      'is-invalid': _vm.errors.has('password'),
      'is-not-empty': _vm.password.length
    },
    attrs: {
      "id": "password",
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "om-form--login__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.tr('Hasło', 'Login')))]), _vm._v(" "), _c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/img/icon-lock.png",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.visibleSubdomain) ? _c('div', {
    staticClass: "om-form--login__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subdomain),
      expression: "subdomain"
    }],
    staticClass: "om-form--login__input--login",
    class: {
      'is-not-empty': _vm.subdomain.length
    },
    attrs: {
      "id": "subdomain",
      "name": "subdomain"
    },
    domProps: {
      "value": (_vm.subdomain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subdomain = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "om-form--login__label",
    attrs: {
      "for": "subdomain"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Subdomena (tymczasowo)', 'Login')))]), _vm._v(" "), _c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/img/icon-person.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "om-form--login__group"
  }, [_c('button', {
    staticClass: "om-form--login--login__submit",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loginAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.tr('Zaloguj się', 'Login')) + "\n          ")])])]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isDispatch) ? _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_vm._v("\n    " + _vm._s(_vm.isReturn() ? _vm.$tr('Zwrot zamówienia', 'Order') : '') + "\n    " + _vm._s(_vm.isCollect() ? _vm.$tr('Odbiór zamówienia', 'Order') : '') + "\n    "), _c('router-link', {
    staticClass: "om-link-back",
    attrs: {
      "to": {
        name: ((this.$route.name) + "List")
      }
    }
  }, [_c('i', {
    staticClass: "om-ico-back-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$tr('wróć', 'Order')) + "\n    ")])], 1), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "om-order"
  }, [_c('ul', {
    staticClass: "om-order__general"
  }, [_c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Zamówienie:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.reference) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Imię i nazwisko:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.firstname + ' ' + _vm.order.lastname) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Telefon:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.phone) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Adres e-mail:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.email) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Nr konta bankowego:', 'Order')))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.editFlags.account_number) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.order.account_number))]), _vm._v(" "), _c('span', {
    staticClass: "om-small-action",
    on: {
      "click": function($event) {
        _vm.editFlags.account_number = !_vm.editFlags.account_number
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$tr('edytuj', 'Order')) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.editFlags.account_number) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.account_number),
      expression: "order.account_number"
    }],
    staticClass: "om-input om-input--inline",
    attrs: {
      "type": "text",
      "size": _vm.order.account_number ? _vm.order.account_number.length : 1,
      "title": _vm.$tr('Nr konta bankowego', 'Order')
    },
    domProps: {
      "value": (_vm.order.account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "account_number", $event.target.value)
      }
    }
  }), _vm._v("\n             \n            "), _c('button', {
    staticClass: "om-btn om-btn--inline",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCustomer({
          account_number: _vm.order.account_number
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$tr('zapisz', 'Order')))])]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.order.products) ? _c('div', {
    staticClass: "om-products"
  }, [_c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$tr('Produkty', 'Order')) + " (" + _vm._s(_vm.order.products.length) + ")")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$tr('Cena jednostkowa (brutto)', 'Order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$tr('Ilość', 'Order')))]), _vm._v(" "), (_vm.isReturn()) ? _c('th', {
    staticClass: "om-text-center"
  }, [_vm._v(_vm._s(_vm.$tr('Informacje o zwrocie', 'Order')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.order.products), function(p, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_c('div', {
      staticClass: "flex cen"
    }, [_c('div', {
      staticClass: "om-products__image"
    }, [_c('img', {
      attrs: {
        "src": p.image,
        "alt": p.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "om-products__desc fg-20"
    }, [_c('h4', {
      staticClass: "om-products__medium"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('h5', {
      staticClass: "om-products__small"
    }, [_vm._v(_vm._s(_vm.$tr('Kod produktu:', 'Order')) + " " + _vm._s(p.reference))]), _vm._v(" "), (p.attributes) ? _c('ul', {
      staticClass: "om-attributes"
    }, _vm._l((p.attributes), function(val, attr) {
      return _c('li', {
        key: attr,
        staticClass: "om-products__small"
      }, [_vm._v("\n                      " + _vm._s(attr) + ": " + _vm._s(val) + "\n                    ")])
    }), 0) : _vm._e()])])]), _vm._v(" "), _c('td', {
      staticClass: "om-std"
    }, [_vm._v(_vm._s(p.price) + " "), _c('span', {
      staticClass: "currency"
    }, [_vm._v(_vm._s(p.currency))])]), _vm._v(" "), _c('td', {
      staticClass: "om-std"
    }, [_vm._v(_vm._s(p.quantity))]), _vm._v(" "), (_vm.isReturn() && key === 0) ? _c('td', {
      staticClass: "om-std om-text-center",
      attrs: {
        "rowspan": _vm.order.products.length
      }
    }, [_c('div', {
      staticClass: "font-normal"
    }, [_vm._v(_vm._s(_vm.$moment(_vm.order.date_return).format('DD.MM.YYYY')) + _vm._s(_vm.$tr('r.', 'Order')))]), _vm._v(" "), _c('div', {
      staticClass: "font-normal"
    }, [_vm._v(_vm._s(_vm.$tr('godz.', 'Order')) + " " + _vm._s(_vm.$moment(_vm.order.date_return).format('HH:mm')))]), _vm._v(" "), _c('div', {
      staticClass: "font-normal"
    }, [_vm._v(_vm._s(_vm.order.store_return.name))])]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  }), _vm._v(" "), (_vm.isCollect()) ? _c('div', [(_vm.collect_store) ? _c('section', {
    staticClass: "om-section"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Adres odbioru', 'Order')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "om-text-sc"
  }, [_c('div', [_vm._v(_vm._s(_vm.collect_store.name))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.$tr('ul.', 'ShopList')) + " " + _vm._s(_vm.collect_store.address.street) + "\n            " + _vm._s(_vm.collect_store.address.house) + "\n            " + _vm._s(typeof _vm.collect_store.address.flat !== 'undefined' && _vm.collect_store.address.flat !== '' ? ("/ " + (_vm.collect_store.address.flat)) : '') + "\n          ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.collect_store.address.postcode) + " " + _vm._s(_vm.collect_store.address.city))])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  }), _vm._v(" "), _c('section', {
    staticClass: "om-section"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Historia zamówienia:', 'Order')) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "om-summary"
  }, [_c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Data złożenia zamówienia:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$moment(_vm.order.date).format('DD.MM.YYYY HH:mm:SS')))])]), _vm._v(" "), (typeof _vm.order.date_store_delivery !== 'undefined') ? _c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Data przyjęcia zamówienia przez sklep stacjonarny:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$moment(_vm.order.date_store_delivery).format('DD.MM.YYYY HH:mm:SS')))])]) : _vm._e(), _vm._v(" "), (_vm.order.collected) ? _c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Data odbioru zamówienia przez klienta:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$moment(_vm.order.date_collect).format('DD.MM.YYYY HH:mm:SS')))])]) : _vm._e()])])]) : (_vm.isReturn()) ? _c('div', [_c('section', {
    staticClass: "om-section"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Podsumowanie zwrotu:', 'Order')) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "om-summary"
  }, [_c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Ilość zwróconych produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.returnSummary.quantity))])]), _vm._v(" "), _c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Wartość zwróconych produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$helper.displayPrice(_vm.returnSummary.value, _vm.returnSummary.currency)))])])])]), _vm._v(" "), _c('section', {
    staticClass: "om-section"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Zwrot zrealizowany:', 'Order')) + "       "), _c('radio', {
    attrs: {
      "disabled": _vm.return_completed,
      "variant": "check",
      "items": [{
        name: 'Zrealizowany',
        value: 1
      }],
      "initial-value": _vm.order.confirmed
    },
    on: {
      "change": _vm.confirmReturn
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  })]) : (_vm.notFound) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.$tr('Brak szczegółów zamówienia', 'Order')) + "\n  ")]) : _c('div')]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-wrapper"
  }, [_c('nav', {
    staticClass: "om-top-nav flex sb"
  }, [_c('div', {
    staticClass: "om-nav-logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "alt": _vm.$tr('Omniway', 'Admin')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-nav-right"
  }, [(_vm.isDispatch) ? _c('router-link', {
    staticClass: "om-nav-right__button",
    attrs: {
      "tag": "button",
      "to": {
        name: 'ShopSettings',
        params: {
          code: 'new'
        }
      }
    }
  }, [_c('span', {
    staticClass: "om-icon-plus"
  }, [_vm._v("+")]), _vm._v("\n        " + _vm._s(_vm.$tr('dodaj nowy sklep', 'Admin')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "om-logout-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.isDispatch ? _vm.$tr('Wyloguj', 'Admin') : (_vm.loggedShop !== null ? _vm.loggedShop.name : _vm.$tr('Wyloguj', 'Admin'))) + "\n        "), _c('img', {
    attrs: {
      "src": "/static/img/logout.png",
      "alt": _vm.$tr('Wyloguj', 'Admin')
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "om-center"
  }, [(_vm.settings && _vm.settings.logo_url) ? _c('img', {
    staticClass: "om-admin-big-logo",
    attrs: {
      "src": _vm.settings.logo_url,
      "alt": _vm.$tr('Omniway', 'Admin')
    }
  }) : _c('img', {
    staticClass: "om-admin-big-logo",
    attrs: {
      "src": "/static/temp/logo-patrizia-aryton.png",
      "alt": _vm.$tr('Omniway', 'Admin')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-layout flex sb clearfix",
    class: [(_vm.isDispatch ? 'om-layout--is-left-column' : '')]
  }, [(_vm.isDispatch) ? _c('aside', {
    staticClass: "om-aside"
  }, [(_vm.isDispatch) ? _c('router-link', {
    staticClass: "om-aside__link",
    attrs: {
      "activeClass": "active",
      "to": "/admin/return-list"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Lista zwrotów', 'Admin')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isDispatch) ? _c('router-link', {
    staticClass: "om-aside__link",
    attrs: {
      "activeClass": "active",
      "to": "/admin/collect-list"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Lista odbiorów', 'Admin')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isDispatch) ? _c('router-link', {
    staticClass: "om-aside__link",
    attrs: {
      "activeClass": "active",
      "to": "/admin/shop-list"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Lista sklepów', 'Admin')) + "\n      ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "om-admin-content"
  }, [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": ['order-list']
    }
  }, [_c('router-view')], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_c('label', {
    attrs: {
      "for": "search"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Lista odbiorów', 'CollectList')))])]), _vm._v(" "), _c('form', {
    staticClass: "om-search flex sb"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "om-search__input fg-20",
    attrs: {
      "id": "search",
      "placeholder": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'CollectList'),
      "title": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'CollectList')
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "om-btn om-search__submit",
    attrs: {
      "placeholder": _vm.$tr('', 'CollectList'),
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$tr('Szukaj', 'CollectList')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading flex sb"
  }, [(_vm.search != '') ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--bright"
  }, [_vm._v(_vm._s(_vm.$tr('Wyniki wyszukiwania:', 'CollectList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.search))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--num"
  }, [_vm._v("(" + _vm._s(_vm.filteredCount) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Pokaż', 'CollectList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.itemsPerPage,
      "default-label": _vm.defaultPerPage.name,
      "default-value": _vm.defaultPerPage.value
    },
    on: {
      "change": _vm.changePerPage
    }
  })], 1), _vm._v(" "), (_vm.storesDefaultFilter) ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Sklep', 'CollectList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.storesFilter,
      "default-label": _vm.storesDefaultFilter.name,
      "default-value": _vm.storesDefaultFilter.value
    },
    on: {
      "change": _vm.changeFilterByStore
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('radio', {
    attrs: {
      "items": _vm.dateRangesFilter
    },
    on: {
      "change": _vm.changeDateRange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Wyświetl:', 'CollectList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.filterByStates,
      "default-label": _vm.defaultByStates.name,
      "default-value": _vm.defaultByStates.value
    },
    on: {
      "change": _vm.changeFilterByState
    }
  })], 1)], 1), _vm._v(" "), (!_vm.noContent) ? _c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.columns.reference))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.shop))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.data))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.status))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageContent), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "reference"
    }, [_vm._v(_vm._s(item.reference))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(typeof item.store_collect !== 'undefined' ? item.store_collect.name : '') + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "font-normal",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.firstname + ' ' + item.lastname, _vm.search))
      }
    })]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.phone))])]), _vm._v(" "), _c('td', {
      staticClass: "status",
      style: ({
        color: item.statusColor
      })
    }, [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('td', {
      staticClass: "more"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Collect',
          params: {
            reference: item.reference
          }
        }
      }
    }, [_c('i', {
      staticClass: "om-ico-zoom",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), 0)]) : _c('div', {
    staticClass: "om-information"
  }, [_vm._v("\n      " + _vm._s(_vm.$tr('Brak wyników. Spróbuj zmienić parametry wyszukiwania.', 'CollectList')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "om-list-footer flex sb"
  }, [_c('div'), _vm._v(" "), _c('paginator', {
    attrs: {
      "items-per-page": _vm.currentPerPage,
      "request": _vm.requestParams,
      "update-force": _vm.requestUpdateForce,
      "passive-mode": true
    },
    on: {
      "change": _vm.updatePageContent
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "om-radio__list flex wrap sb",
    class: [(("om-radio__list--" + _vm.variant))]
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      class: [_vm.choosedValue === item.value ? 'active' : '', _vm.variantClass],
      attrs: {
        "title": (_vm.variant === 'check' && item.name ? item.name : null)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeAction(item.value)
        }
      }
    }, [(_vm.variant === 'button' && typeof item.name !== 'undefined') ? _c('span', [_vm._v(_vm._s(item.name))]) : (_vm.variant === 'button' && typeof item.value !== 'undefined') ? _c('span', [_vm._v(_vm._s(item.value))]) : _vm._e()])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_c('label', {
    attrs: {
      "for": "search"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Lista sklepów', 'ShopList')))])]), _vm._v(" "), _c('form', {
    staticClass: "om-search flex sb",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "om-search__input fg-20",
    attrs: {
      "id": "search",
      "placeholder": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'ShopList'),
      "title": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'ShopList')
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "om-btn om-search__submit",
    attrs: {
      "type": "submit",
      "placeholder": _vm.$tr('', 'ShopList')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$tr('Szukaj', 'ShopList')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading flex sb"
  }, [(_vm.search != '') ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--bright"
  }, [_vm._v(_vm._s(_vm.$tr('Wyniki wyszukiwania:', 'ShopList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.search))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--num"
  }, [_vm._v("(" + _vm._s(_vm.filteredCount) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Pokaż', 'ShopList')) + "\n      ")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.itemsPerPage,
      "default-label": _vm.defaultPerPage.name,
      "default-value": _vm.defaultPerPage.value
    },
    on: {
      "change": _vm.changePerPage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Wyświetl:', 'ShopList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.displayOptions,
      "default-label": _vm.displayOptionCurrent ? _vm.displayOptionCurrent.name : null,
      "default-value": _vm.displayOptionCurrent ? _vm.displayOptionCurrent.value : null
    },
    on: {
      "change": _vm.sortBy
    }
  })], 1)]), _vm._v(" "), (_vm.pageContent.length) ? _c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.columns.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.code))]), _vm._v(" "), _c('th', {
    staticClass: "td--cen"
  }, [_vm._v(_vm._s(_vm.columns.orders))]), _vm._v(" "), _c('th', {
    staticClass: "td--cen"
  }, [_vm._v(_vm._s(_vm.columns.settings))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageContent), function(item) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "font-normal"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.$tr('ul.', 'ShopList')) + " " + _vm._s(item.address.street) + "\n            " + _vm._s(item.address.house) + "\n            " + _vm._s(typeof item.address.flat !== 'undefined' && item.address.flat !== '' ? ("/ " + (item.address.flat)) : '') + "\n          ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.address.postcode) + " " + _vm._s(item.address.city))])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(item.code) + "\n        ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "flex sb"
    }, [_c('button', {
      staticClass: "om-btn om-btn--check",
      class: [item.can_return ? 'is-active' : ''],
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.can_return = !item.can_return;
          _vm.updateShop(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$tr('Zwrot', 'ShopList')) + "\n            ")]), _vm._v(" "), _c('button', {
      staticClass: "om-btn om-btn--check",
      class: [item.can_collect ? 'is-active' : ''],
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.can_collect = !item.can_collect;
          _vm.updateShop(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$tr('Odbiór', 'ShopList')) + "\n            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "more td--cen"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ShopSettings',
          params: {
            code: item.code
          }
        }
      }
    }, [_c('i', {
      staticClass: "om-ico-tools",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), 0)]) : _c('div', [_vm._v(_vm._s(_vm.$tr('Brak wyników wyszukiwania', 'ShopList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-footer flex sb"
  }, [_c('div', {
    staticClass: "om-add-shop"
  }, [_c('router-link', {
    staticClass: "om-btn--add-shop",
    attrs: {
      "to": {
        name: 'ShopSettings',
        params: {
          code: 'new'
        }
      },
      "tag": "button",
      "id": "cta-add-new-shop"
    }
  }, [_c('div', {
    staticClass: "om-btn__upper-txt"
  }, [_vm._v(_vm._s(_vm.$tr('Dodaj nowy sklep', 'ShopList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-btn__lower-txt"
  }, [_vm._v(_vm._s(_vm.$tr('Utwórz konto dla nowego sklepu', 'ShopList')))])])], 1), _vm._v(" "), _c('paginator', {
    attrs: {
      "items-per-page": _vm.currentPerPage,
      "passive-mode": _vm.paginatorPassive,
      "request": _vm.request,
      "update-force": _vm.requestUpdateForce
    },
    on: {
      "change": _vm.updatePageContent
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "om-paginator__list flex wrap sb"
  }, [(_vm.page > 1) ? _c('li', {
    staticClass: "om-paginator__prev om-paginator__page",
    on: {
      "click": function($event) {
        return _vm.changeAction(_vm.page - 1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pagesCount > 1) ? _c('li', {
    staticClass: "om-paginator__page",
    class: [_vm.page === 1 ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.changeAction(1)
      }
    }
  }, [_vm._v(_vm._s(1))]) : _vm._e(), _vm._v(" "), (_vm.beforeDots) ? _c('li', {
    staticClass: "om-paginator__page om-paginator__dots"
  }, [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.spread * 2 + 1)), function(n) {
    return (n + _vm.page - (_vm.spread * 2) + 1 < _vm.pagesCount && n + _vm.page - (_vm.spread * 2) > 0) ? _c('li', {
      staticClass: "om-paginator__page",
      class: [_vm.page === (n + _vm.page - (_vm.spread * 2) + 1) ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.changeAction(n + _vm.page - (_vm.spread * 2) + 1)
        }
      }
    }, [_vm._v(_vm._s(n + _vm.page - (_vm.spread * 2) + 1))]) : _vm._e()
  }), _vm._v(" "), (_vm.afterDots) ? _c('li', {
    staticClass: "om-paginator__page om-paginator__dots"
  }, [_vm._v("...")]) : _vm._e(), _vm._v(" "), (_vm.pagesCount >= 2) ? _c('li', {
    staticClass: "om-paginator__page",
    class: [_vm.page === _vm.pagesCount ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.changeAction(_vm.pagesCount)
      }
    }
  }, [_vm._v(_vm._s(_vm.pagesCount))]) : _vm._e(), _vm._v(" "), (_vm.page < _vm.pagesCount) ? _c('li', {
    staticClass: "om-paginator__next om-paginator__page",
    on: {
      "click": function($event) {
        return _vm.changeAction(_vm.page + 1)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_c('label', {
    attrs: {
      "for": "search"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Lista zamówień', 'OrderList')))])]), _vm._v(" "), _c('form', {
    staticClass: "om-search flex sb",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "om-search__input fg-20",
    attrs: {
      "id": "search",
      "placeholder": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'OrderList'),
      "title": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'OrderList')
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "om-btn om-search__submit",
    attrs: {
      "type": "submit",
      "placeholder": _vm.$tr('', 'OrderList')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$tr('Szukaj', 'OrderList')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading flex sb"
  }, [(_vm.pageContent instanceof Array && _vm.pageContent.length) ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--bright"
  }, [_vm._v(_vm._s(_vm.$tr('Wyniki wyszukiwania:', 'OrderList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.searchValue))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--num"
  }, [_vm._v("(" + _vm._s(_vm.searchResultsCount) + ")")])]) : _vm._e()]), _vm._v(" "), (!_vm.noContent) ? _c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.columns.reference))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.date))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.firstname))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.status))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.details))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageContent), function(item, k) {
    return _c('tr', {
      key: k
    }, [_c('td', {
      staticClass: "reference"
    }, [_vm._v(_vm._s(item.reference))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$moment(item.date).format('DD.MM.YYYY')))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "font-normal",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.firstname + ' ' + item.lastname, _vm.search))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "status",
      style: ({
        color: item.statusColor
      })
    }, [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('td', {
      staticClass: "more"
    }, [_c('router-link', {
      attrs: {
        "to": '/admin/order-list/' + item.reference
      }
    }, [_c('i', {
      staticClass: "om-ico-zoom",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), 0)]) : (typeof _vm.request.params.query !== 'undefined' && _vm.request.params.query != '') ? _c('div', {
    staticClass: "om-information"
  }, [_vm._v("\n    " + _vm._s(_vm.$tr('Brak wyników. Spróbuj zmienić parametry wyszukiwania.', 'OrderList')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "om-list-footer flex sb"
  }, [_c('div'), _vm._v(" "), _c('paginator', {
    attrs: {
      "items-per-page": _vm.currentPerPage,
      "passive-mode": _vm.paginatorPassive,
      "request": _vm.request,
      "update-force": _vm.requestUpdateForce,
      "active": _vm.activeListing
    },
    on: {
      "change": _vm.updatePageContent,
      "results-count": _vm.updateResultsCount
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[196]);


// WEBPACK FOOTER //
// static/js/app.833c70d12c7304a1e816.js